var _metadata, _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAstronoutStandingCongratulate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.3333 1333.3333",
    height: 1333.3333,
    width: 1333.3333,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcformat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dctype", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 0,1000 H 1000 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath44",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "m 186.529,750.305 h 53.945 V 598.537 h -53.945 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath68",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path66",
    d: "m 155.579,836.564 h 14.114 v -13.193 h -14.114 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath84",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path82",
    d: "m 175.945,830.995 h 11.331 v -17.303 h -11.331 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath100",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path98",
    d: "m 132.188,858.91 h 16.357 v -14.523 h -16.357 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath136",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path134",
    d: "M 96.1666,611.207 H 111.812 V 598.873 H 96.1666 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath152",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M 89.6083,632.824 H 106.186 V 618.787 H 89.6083 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath168",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M 96.7788,579.707 H 115.771 V 565.023 H 96.7788 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath332",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path330",
    d: "m 755.746,750.305 h 53.945 V 598.537 h -53.945 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath360",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M 826.527,836.564 H 840.64 V 823.371 H 826.527 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath376",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path374",
    d: "m 808.943,830.995 h 11.331 v -17.303 h -11.331 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath392",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path390",
    d: "m 847.675,858.91 h 16.357 v -14.523 h -16.357 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath428",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path426",
    d: "m 884.408,611.207 h 15.645 v -12.334 h -15.645 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath444",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path442",
    d: "m 890.033,632.824 h 16.578 v -14.037 h -16.578 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath460",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path458",
    d: "m 880.449,579.707 h 18.992 v -14.684 h -18.992 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath612",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path610",
    d: "M 361.451,469.156 H 632.003 V 269.579 H 361.451 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath632",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path630",
    d: "M 242.808,108.281 H 750.646 V 39.4998 H 242.808 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath652",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path650",
    d: "m 378.562,433.245 h 236.33 V 247.473 h -236.33 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath680",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path678",
    d: "M 679.439,605.197 H 801.848 V 525.398 H 679.439 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath696",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path694",
    d: "M 611.911,585.314 H 800.669 V 403.588 H 611.911 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath744",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path742",
    d: "m 191.612,605.197 h 122.41 v -79.799 h -122.41 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath760",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path758",
    d: "M 192.791,585.314 H 381.55 V 403.588 H 192.791 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath824",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path822",
    d: "m 552.101,166.699 h 52.785 v -39.001 h -52.785 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath844",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path842",
    d: "m 604.263,265.902 h 1.718 v -24.331 h -1.718 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath860",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path858",
    d: "M 507.046,330.454 H 634.848 V 69.8119 H 507.046 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath892",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path890",
    d: "m 589.951,117.348 h 29.842 v -14.296 h -29.842 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath916",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path914",
    d: "m 388.569,166.699 h 52.785 v -39.001 h -52.785 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath936",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path934",
    d: "m 387.473,265.902 h 1.719 v -24.331 h -1.719 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath952",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path950",
    d: "M 358.606,330.454 H 486.409 V 69.8119 H 358.606 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath984",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path982",
    d: "m 373.661,117.348 h 29.842 v -14.296 h -29.842 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1004",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1002",
    d: "m 419.424,362.673 h 154.78 v -48.836 h -154.78 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1032",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1030",
    d: "m 540.28,510.205 h 89.556 V 402.232 H 540.28 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1072",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1070",
    d: "M 363.763,510.205 H 453.32 V 402.232 h -89.557 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1160",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1158",
    d: "M 377.604,526.922 H 619.255 V 465.503 H 377.604 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1180",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1178",
    d: "m 307.339,630.485 h 45.032 v -57.092 h -45.032 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1204",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1202",
    d: "m 641.084,630.485 h 45.031 v -57.092 h -45.031 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1236",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1234",
    d: "M 325.072,725.947 H 667.199 V 488.724 H 325.072 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1260",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1258",
    d: "M 349.384,716.857 H 508.557 V 591.245 H 349.384 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1276",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1274",
    d: "m 610.026,644.826 h 32.861 v -39.749 h -32.861 z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1292",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1290",
    d: "m 594.512,597.606 h 20.624 v -20.624 h -20.624 z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1333.3333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.0063,754.748)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.414,1.263 28.005,10.755 41.678,8.723 L 61.375,-208.613 44.25,-209.645 C 44.25,-209.645 -0.414,-1.263 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217.4873,763.498)",
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#f95353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -12.353,-25.05 -26.562,-38.12 l 4.82,-22.942 c 0,0 20.081,17.961 32.146,47.715 l -1.207,13.32 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(230.52,721.1421)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#f95353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -8.454,-27.332 -28.235,-49.609 l 4.857,-22.861 c 0,0 14.941,11.795 26.479,38.253 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.1899,658.5815)",
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#f95353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -7.261,-21.713 -23.088,-37.895 l 4.667,-21.871 c 0,0 14.991,13.526 20.951,31.856 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g52"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g50",
    clipPath: "url(#clipPath44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(240.4736,611.3179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -7.939,-1.253 -13.15,3.449 -5.211,4.702 -33.932,135.538 -33.932,135.538 h -6.863 l 30.247,-150.153 c 0,0 15.448,-2.418 17.891,-1.336 C -3.364,-11.42 0,-9.42 0,-9.42 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.0063,754.748)",
    id: "g54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0.414,1.263 28.005,10.755 41.678,8.723 L 61.375,-208.613 44.25,-209.645 C 44.25,-209.645 -0.414,-1.263 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.9648,825.1865)",
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#ffe564",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -4.418,-1.223 -7.713,-4.373 -8.232,-6.59 -0.106,-0.454 -0.304,-1.298 1.2,-2.643 0.565,-0.509 0.722,-0.449 1.144,-0.283 2.071,0.807 5.081,4.607 6.91,9.756 C 0.647,0.168 0.302,0.084 0,0 m 7.48,-27.239 c -2.512,1.663 -3.202,5.052 -1.549,7.572 0.058,0.086 4.164,6.442 3.815,12.455 -2.679,-5.668 -6.678,-10.554 -11.66,-12.496 -4.344,-1.694 -8.87,-0.847 -12.413,2.323 -4.088,3.657 -5.706,8.376 -4.556,13.288 1.53,6.536 7.945,12.419 15.965,14.64 1.841,0.509 3.646,0.785 5.388,0.835 -0.371,3.079 -1.597,6.449 -4.832,8.505 -13.506,8.585 -22.785,1.33 -23.758,0.511 -2.266,-1.997 -5.723,-1.777 -7.719,0.489 -1.997,2.266 -1.779,5.723 0.488,7.72 5.459,4.81 20.191,11.106 36.858,0.511 6.76,-4.298 10.348,-11.958 10.022,-21.228 0.523,-0.417 1.022,-0.869 1.495,-1.358 12.607,-13 0.539,-31.467 0.019,-32.247 -1.052,-1.579 -2.78,-2.431 -4.544,-2.431 -1.038,0 -2.088,0.296 -3.019,0.911"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g76"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g74",
    clipPath: "url(#clipPath68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g72",
    transform: "translate(155.5796,830.9956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 4.134,-0.271 5.142,-2.436 1.008,-2.165 0,-5.189 0,-5.189 0,0 5.545,2.419 5.948,2.621 0.404,0.202 1.317,1.191 1.317,1.191 0,0 1.163,3.796 1.637,5.89 0.474,2.094 -1.637,3.492 -1.637,3.492 C 12.407,5.569 3.629,3.895 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g78"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g92"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g90",
    clipPath: "url(#clipPath84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g88",
    transform: "translate(187.2373,817.9746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -7.469,-0.59 -9.78,-4.283 l -1.512,3.63 c 0,0 1.698,3.1 1.894,3.704 0.196,0.603 2.034,7.928 2.034,7.928 l 2.121,2.042 C -5.243,13.021 0.567,7.95 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g94"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g108"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g106",
    clipPath: "url(#clipPath100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g104",
    transform: "translate(148.5449,848.9492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -5.719,4.138 -3.073,9.961 0,0 -6.736,-0.823 -9.786,-3.544 C -15.91,3.697 -17.478,1 -15.436,-2.365 -13.394,-5.729 -9.16,-4.671 -7.081,-2.894 -5.001,-1.117 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.9648,825.1865)",
    id: "g110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -4.418,-1.223 -7.713,-4.373 -8.232,-6.59 -0.106,-0.454 -0.304,-1.298 1.2,-2.643 0.565,-0.509 0.722,-0.449 1.144,-0.283 2.071,0.807 5.081,4.607 6.91,9.756 C 0.647,0.168 0.302,0.084 0,0 Z m 7.48,-27.239 c -2.512,1.663 -3.202,5.052 -1.549,7.572 0.058,0.086 4.164,6.442 3.815,12.455 -2.679,-5.668 -6.678,-10.554 -11.66,-12.496 -4.344,-1.694 -8.87,-0.847 -12.413,2.323 -4.088,3.657 -5.706,8.376 -4.556,13.288 1.53,6.536 7.945,12.419 15.965,14.64 1.841,0.509 3.646,0.785 5.388,0.835 -0.371,3.079 -1.597,6.449 -4.832,8.505 -13.506,8.585 -22.785,1.33 -23.758,0.511 -2.266,-1.997 -5.723,-1.777 -7.719,0.489 -1.997,2.266 -1.779,5.723 0.488,7.72 5.459,4.81 20.191,11.106 36.858,0.511 6.76,-4.298 10.348,-11.958 10.022,-21.228 0.523,-0.417 1.022,-0.869 1.495,-1.358 12.607,-13 0.539,-31.467 0.019,-32.247 -1.052,-1.579 -2.78,-2.431 -4.544,-2.431 -1.038,0 -2.088,0.296 -3.019,0.911 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.7104,817.9746)",
    id: "g114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 2.787,6.35 3.783,15.098"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.9868,825.4268)",
    id: "g118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 2.298,4.369 1.448,11.138"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.6191,611.959)",
    id: "g122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 4.335,-2.388 9.257,-2.441 11.331,-1.121 0.424,0.271 1.213,0.774 1.066,2.948 -0.052,0.819 -0.219,0.891 -0.67,1.082 C 9.519,3.847 4.327,3.183 -0.97,0.585 -0.626,0.358 -0.296,0.163 0,0 m 14.772,26.683 c 0.686,-3.18 -1.338,-6.318 -4.516,-7.017 -0.109,-0.023 -8.076,-1.835 -12.343,-6.743 6.346,2.357 13.12,3.114 18.434,0.856 4.633,-1.969 7.49,-6.038 7.836,-11.159 0.398,-5.909 -1.912,-10.775 -6.506,-13.702 -6.113,-3.894 -15.507,-3.598 -23.376,0.736 -1.806,0.996 -3.409,2.145 -4.793,3.421 -2.035,-2.658 -3.631,-6.187 -2.683,-10.215 3.954,-16.82 16.596,-18.218 17.965,-18.318 3.257,-0.167 5.761,-2.945 5.594,-6.202 -0.168,-3.257 -2.945,-5.762 -6.202,-5.594 -7.846,0.402 -23.974,6.653 -28.855,27.412 -1.98,8.419 1.028,17.043 8.274,23.957 -0.09,0.717 -0.134,1.443 -0.131,2.177 0.071,19.553 23.324,24.713 24.314,24.924 2.004,0.425 3.981,-0.221 5.343,-1.552 0.802,-0.783 1.391,-1.803 1.645,-2.981"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.6191,611.959)",
    id: "g126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 4.335,-2.388 9.257,-2.441 11.331,-1.121 0.424,0.271 1.213,0.774 1.066,2.948 -0.052,0.819 -0.219,0.891 -0.67,1.082 C 9.519,3.847 4.327,3.183 -0.97,0.585 -0.626,0.358 -0.296,0.163 0,0 Z m 14.772,26.683 c 0.686,-3.18 -1.338,-6.318 -4.516,-7.017 -0.109,-0.023 -8.076,-1.835 -12.343,-6.743 6.346,2.357 13.12,3.114 18.434,0.856 4.633,-1.969 7.49,-6.038 7.836,-11.159 0.398,-5.909 -1.912,-10.775 -6.506,-13.702 -6.113,-3.894 -15.507,-3.598 -23.376,0.736 -1.806,0.996 -3.409,2.145 -4.793,3.421 -2.035,-2.658 -3.631,-6.187 -2.683,-10.215 3.954,-16.82 16.596,-18.218 17.965,-18.318 3.257,-0.167 5.761,-2.945 5.594,-6.202 -0.168,-3.257 -2.945,-5.762 -6.202,-5.594 -7.846,0.402 -23.974,6.653 -28.855,27.412 -1.98,8.419 1.028,17.043 8.274,23.957 -0.09,0.717 -0.134,1.443 -0.131,2.177 0.071,19.553 23.324,24.713 24.314,24.924 2.004,0.425 3.981,-0.221 5.343,-1.552 0.802,-0.783 1.391,-1.803 1.645,-2.981 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g130"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g132"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g144"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g142",
    clipPath: "url(#clipPath136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g140",
    transform: "translate(110.0313,598.8823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -2.989,3.328 -2.134,5.761 0.854,2.432 3.915,4.008 3.915,4.008 0,0 -6.109,2.314 -6.573,2.463 -0.463,0.148 -1.916,0.073 -1.916,0.073 0,0 -3.761,-2.054 -5.707,-3.314 -1.946,-1.26 -1.37,-3.932 -1.37,-3.932 0,0 8.043,-5.329 13.785,-5.059"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g146"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g148"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g160"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g158",
    clipPath: "url(#clipPath152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g156",
    transform: "translate(95.4014,632.8237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 6.214,-5.179 10.785,-4.07 l -1.57,-3.944 c 0,0 -3.651,-1.114 -4.257,-1.433 -0.607,-0.318 -7.553,-4.59 -7.553,-4.59 l -3.179,0.024 c 0,0 -0.662,8.3 5.774,14.013"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g162"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g164"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g176"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g174",
    clipPath: "url(#clipPath168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g172",
    transform: "translate(101.9199,579.7075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path170",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 1.296,-7.511 -5.141,-10.012 0,0 5.824,-4.446 10.233,-4.647 4.408,-0.199 7.654,0.701 8.615,4.84 0.961,4.14 -3.108,6.516 -6.055,6.713 C 4.706,-2.91 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.6191,611.959)",
    id: "g178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 4.335,-2.388 9.257,-2.441 11.331,-1.121 0.424,0.271 1.213,0.774 1.066,2.948 -0.052,0.819 -0.219,0.891 -0.67,1.082 C 9.519,3.847 4.327,3.183 -0.97,0.585 -0.626,0.358 -0.296,0.163 0,0 Z m 14.772,26.683 c 0.686,-3.18 -1.338,-6.318 -4.516,-7.017 -0.109,-0.023 -8.076,-1.835 -12.343,-6.743 6.346,2.357 13.12,3.114 18.434,0.856 4.633,-1.969 7.49,-6.038 7.836,-11.159 0.398,-5.909 -1.912,-10.775 -6.506,-13.702 -6.113,-3.894 -15.507,-3.598 -23.376,0.736 -1.806,0.996 -3.409,2.145 -4.793,3.421 -2.035,-2.658 -3.631,-6.187 -2.683,-10.215 3.954,-16.82 16.596,-18.218 17.965,-18.318 3.257,-0.167 5.761,-2.945 5.594,-6.202 -0.168,-3.257 -2.945,-5.762 -6.202,-5.594 -7.846,0.402 -23.974,6.653 -28.855,27.412 -1.98,8.419 1.028,17.043 8.274,23.957 -0.09,0.717 -0.134,1.443 -0.131,2.177 0.071,19.553 23.324,24.713 24.314,24.924 2.004,0.425 3.981,-0.221 5.343,-1.552 0.802,-0.783 1.391,-1.803 1.645,-2.981 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103.5322,624.8818)",
    id: "g182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -6.943,-2.802 -14.313,-8.808"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.6489,612.5444)",
    id: "g186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -5.071,-1.641 -9.521,-7.51"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.1553,285.4414)",
    id: "g190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#ff5235",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 24.644,4.054 25.185,28.748 l -12.089,1.355 c 0,0 -1.536,-16.055 -19.493,-17.694 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.1553,285.4414)",
    id: "g194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 24.644,4.054 25.185,28.748 l -12.089,1.355 c 0,0 -1.536,-16.055 -19.493,-17.694 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.2813,370.334)",
    id: "g198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#ff5235",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -8.798,20.979 -30.792,16.242 l 1.353,-10.997 c 0,0 14.55,2.03 19.795,-13.535 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.2813,370.334)",
    id: "g202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -8.798,20.979 -30.792,16.242 l 1.353,-10.997 c 0,0 14.55,2.03 19.795,-13.535 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.5171,842.3291)",
    id: "g206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#ff5235",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -27.458,3.467 -35.822,-22.596 l 12.414,-5.252 c 0,0 6.697,16.572 26.29,12.647 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.5171,842.3291)",
    id: "g210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -27.458,3.467 -35.822,-22.596 l 12.414,-5.252 c 0,0 6.697,16.572 26.29,12.647 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.5679,764.0332)",
    id: "g214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#ffa3f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -18.497,-20.311 -2.117,-41.986 l 11.355,7.079 c 0,0 -9.628,14.9 4.748,28.565 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.5679,764.0332)",
    id: "g218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -18.497,-20.311 -2.117,-41.986 l 11.355,7.079 c 0,0 -9.628,14.9 4.748,28.565 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.5337,523.0903)",
    id: "g222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path224",
    style: {
      fill: "#ffa3f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -21.901,-7.592 -18.503,-30.264 l 11.27,0.667 c 0,0 -1.125,14.927 15.041,19.255 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.5337,523.0903)",
    id: "g226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -21.901,-7.592 -18.503,-30.264 l 11.27,0.667 c 0,0 -1.125,14.927 15.041,19.255 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260.6748,847.5806)",
    id: "g230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -25.551,-1.125 -29.104,-26.169 l 12.127,-2.847 c 0,0 3.515,16.138 21.974,15.62 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260.6748,847.5806)",
    id: "g234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path236",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -25.551,-1.125 -29.104,-26.169 l 12.127,-2.847 c 0,0 3.515,16.138 21.974,15.62 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.7178,880.9272)",
    id: "g238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path240",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 10.388,18.874 -6.07,32.404 l -7.363,-7.476 c 0,0 10.069,-9.6 1.607,-22.652 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(397.7178,880.9272)",
    id: "g242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path244",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 10.388,18.874 -6.07,32.404 l -7.363,-7.476 c 0,0 10.069,-9.6 1.607,-22.652 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.7554,440.9648)",
    id: "g246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path248",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 2.173,20.37 -17.234,26.187 l -3.709,-9.262 c 0,0 12.359,-4.719 9.735,-19.276 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.7554,440.9648)",
    id: "g250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 2.173,20.37 -17.234,26.187 l -3.709,-9.262 c 0,0 12.359,-4.719 9.735,-19.276 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.7065,714.8257)",
    id: "g254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path256",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -23.164,-1.02 -26.385,-23.724 l 10.994,-2.581 c 0,0 3.186,14.63 19.921,14.16 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.7065,714.8257)",
    id: "g258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path260",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -23.164,-1.02 -26.385,-23.724 l 10.994,-2.581 c 0,0 3.186,14.63 19.921,14.16 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.9448,897.1294)",
    id: "g262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path264",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 14.018,21.504 -4.338,39.042 l -9.412,-8.23 c 0,0 11.112,-12.301 -0.1,-27.059 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.9448,897.1294)",
    id: "g266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path268",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 14.018,21.504 -4.338,39.042 l -9.412,-8.23 c 0,0 11.112,-12.301 -0.1,-27.059 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.5444,374.8555)",
    id: "g270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path272",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 13.291,-21.099 36.217,-12.015 l -3.444,11.647 c 0,0 -15.365,-4.817 -23.839,11.068 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.5444,374.8555)",
    id: "g274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path276",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 13.291,-21.099 36.217,-12.015 l -3.444,11.647 c 0,0 -15.365,-4.817 -23.839,11.068 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.3096,776.5176)",
    id: "g278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path280",
    style: {
      fill: "#ffdb48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -19.374,-0.854 -22.068,-19.842 l 9.195,-2.159 c 0,0 2.665,12.236 16.662,11.843 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.3096,776.5176)",
    id: "g282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path284",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -19.374,-0.854 -22.068,-19.842 l 9.195,-2.159 c 0,0 2.665,12.236 16.662,11.843 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(298.3784,923.2041)",
    id: "g286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path288",
    style: {
      fill: "#ffdb48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -24.986,-1.1 -28.46,-25.589 l 11.859,-2.785 c 0,0 3.436,15.781 21.487,15.274 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(298.3784,923.2041)",
    id: "g290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -24.986,-1.1 -28.46,-25.589 l 11.859,-2.785 c 0,0 3.436,15.781 21.487,15.274 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.0381,527.9077)",
    id: "g294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path296",
    style: {
      fill: "#ffdb48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 8.24,-24.733 33.782,-21.22 l -0.596,12.683 c 0,0 -16.802,-1.063 -21.45,17.177 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.0381,527.9077)",
    id: "g298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path300",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 8.24,-24.733 33.782,-21.22 l -0.596,12.683 c 0,0 -16.802,-1.063 -21.45,17.177 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.0205,436.1152)",
    id: "g302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path304",
    style: {
      fill: "#ffdb48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -22.045,-12.549 -13.855,-36.262 l 11.992,2.972 c 0,0 -4.196,15.835 12.332,23.726 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.0205,436.1152)",
    id: "g306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path308",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -22.045,-12.549 -13.855,-36.262 l 11.992,2.972 c 0,0 -4.196,15.835 12.332,23.726 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(811.2129,754.748)",
    id: "g310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path312",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.414,1.263 -28.005,10.755 -41.678,8.723 l -19.696,-217.336 17.124,-1.032 c 0,0 44.664,208.382 44.25,209.645"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(778.7324,763.498)",
    id: "g314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path316",
    style: {
      fill: "#f95353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 12.353,-25.05 26.562,-38.12 l -4.821,-22.942 c 0,0 -20.08,17.961 -32.145,47.715 l 1.207,13.32 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(765.6992,721.1421)",
    id: "g318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path320",
    style: {
      fill: "#f95353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 8.454,-27.332 28.235,-49.609 L 23.379,-72.47 c 0,0 -14.941,11.795 -26.48,38.253 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760.0293,658.5815)",
    id: "g322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path324",
    style: {
      fill: "#f95353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 7.261,-21.713 23.088,-37.895 l -4.666,-21.871 c 0,0 -14.992,13.526 -20.951,31.856 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g326"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g328"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g340"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g338",
    clipPath: "url(#clipPath332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g336",
    transform: "translate(755.7461,611.3179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path334",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 7.939,-1.253 13.15,3.449 5.21,4.702 33.932,135.538 33.932,135.538 h 6.862 L 23.698,-11.166 c 0,0 -15.448,-2.418 -17.891,-1.336 C 3.364,-11.42 0,-9.42 0,-9.42 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(811.2129,754.748)",
    id: "g342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path344",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -0.414,1.263 -28.005,10.755 -41.678,8.723 l -19.696,-217.336 17.124,-1.032 c 0,0 44.664,208.382 44.25,209.645 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828.2324,825.4268)",
    id: "g346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path348",
    style: {
      fill: "#ffa3f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 1.829,-5.149 4.84,-8.949 6.91,-9.756 0.422,-0.166 0.579,-0.226 1.145,0.283 1.504,1.345 1.305,2.189 1.2,2.643 C 8.735,-4.613 5.44,-1.463 1.022,-0.24 0.72,-0.156 0.375,-0.072 0,0 m -9.477,-28.39 c -1.764,0 -3.492,0.851 -4.544,2.431 -0.52,0.779 -12.587,19.247 0.019,32.247 0.474,0.489 0.973,0.941 1.495,1.358 -0.326,9.27 3.262,16.93 10.023,21.228 16.667,10.595 31.398,4.299 36.857,-0.512 2.267,-1.996 2.485,-5.453 0.489,-7.719 -1.997,-2.267 -5.454,-2.486 -7.72,-0.489 C 26.17,20.973 16.89,28.228 3.385,19.643 0.15,17.587 -1.076,14.216 -1.448,11.138 0.294,11.088 2.1,10.812 3.94,10.303 11.96,8.082 18.375,2.199 19.905,-4.337 c 1.151,-4.912 -0.468,-9.631 -4.555,-13.288 -3.543,-3.17 -8.07,-4.018 -12.414,-2.323 -4.982,1.942 -8.981,6.827 -11.66,12.496 -0.348,-6.013 3.758,-12.369 3.815,-12.455 1.653,-2.52 0.964,-5.909 -1.549,-7.572 -0.931,-0.616 -1.98,-0.911 -3.019,-0.911"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828.2324,825.4268)",
    id: "g350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path352",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 1.829,-5.149 4.84,-8.949 6.91,-9.756 0.422,-0.166 0.579,-0.226 1.145,0.283 1.504,1.345 1.305,2.189 1.2,2.643 C 8.735,-4.613 5.44,-1.463 1.022,-0.24 0.72,-0.156 0.375,-0.072 0,0 Z m -9.477,-28.39 c -1.764,0 -3.492,0.851 -4.544,2.431 -0.52,0.779 -12.587,19.247 0.019,32.247 0.474,0.489 0.973,0.941 1.495,1.358 -0.326,9.27 3.262,16.93 10.023,21.228 16.667,10.595 31.398,4.299 36.857,-0.512 2.267,-1.996 2.485,-5.453 0.489,-7.719 -1.997,-2.267 -5.454,-2.486 -7.72,-0.489 C 26.17,20.973 16.89,28.228 3.385,19.643 0.15,17.587 -1.076,14.216 -1.448,11.138 0.294,11.088 2.1,10.812 3.94,10.303 11.96,8.082 18.375,2.199 19.905,-4.337 c 1.151,-4.912 -0.468,-9.631 -4.555,-13.288 -3.543,-3.17 -8.07,-4.018 -12.414,-2.323 -4.982,1.942 -8.981,6.827 -11.66,12.496 -0.348,-6.013 3.758,-12.369 3.815,-12.455 1.653,-2.52 0.964,-5.909 -1.549,-7.572 -0.931,-0.616 -1.98,-0.911 -3.019,-0.911 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g354"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g356"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g368"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g366",
    clipPath: "url(#clipPath360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g364",
    transform: "translate(840.6396,830.9956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -4.133,-0.271 -5.142,-2.436 -1.007,-2.165 0,-5.189 0,-5.189 0,0 -5.545,2.419 -5.948,2.621 -0.403,0.202 -1.317,1.191 -1.317,1.191 0,0 -1.162,3.796 -1.637,5.89 -0.474,2.094 1.637,3.492 1.637,3.492 0,0 8.778,-1.674 12.407,-5.569"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g370"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g372"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g384"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g382",
    clipPath: "url(#clipPath376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g380",
    transform: "translate(808.9824,817.9746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path378",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 7.469,-0.59 9.779,-4.283 l 1.513,3.63 c 0,0 -1.698,3.1 -1.895,3.704 -0.195,0.603 -2.033,7.928 -2.033,7.928 L 5.242,13.021 C 5.242,13.021 -0.567,7.95 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g386"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g388"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g400"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g398",
    clipPath: "url(#clipPath392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g396",
    transform: "translate(847.6748,848.9492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path394",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 5.719,4.138 3.072,9.961 0,0 6.738,-0.823 9.787,-3.544 C 15.909,3.697 17.478,1 15.436,-2.365 13.395,-5.729 9.16,-4.671 7.08,-2.894 5.001,-1.117 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828.2324,825.4268)",
    id: "g402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path404",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 1.829,-5.149 4.84,-8.949 6.91,-9.756 0.422,-0.166 0.579,-0.226 1.145,0.283 1.504,1.345 1.305,2.189 1.2,2.643 C 8.735,-4.613 5.44,-1.463 1.022,-0.24 0.72,-0.156 0.375,-0.072 0,0 Z m -9.477,-28.39 c -1.764,0 -3.492,0.851 -4.544,2.431 -0.52,0.779 -12.587,19.247 0.019,32.247 0.474,0.489 0.973,0.941 1.495,1.358 -0.326,9.27 3.262,16.93 10.023,21.228 16.667,10.595 31.398,4.299 36.857,-0.512 2.267,-1.996 2.485,-5.453 0.489,-7.719 -1.997,-2.267 -5.454,-2.486 -7.72,-0.489 C 26.17,20.973 16.89,28.228 3.385,19.643 0.15,17.587 -1.076,14.216 -1.448,11.138 0.294,11.088 2.1,10.812 3.94,10.303 11.96,8.082 18.375,2.199 19.905,-4.337 c 1.151,-4.912 -0.468,-9.631 -4.555,-13.288 -3.543,-3.17 -8.07,-4.018 -12.414,-2.323 -4.982,1.942 -8.981,6.827 -11.66,12.496 -0.348,-6.013 3.758,-12.369 3.815,-12.455 1.653,-2.52 0.964,-5.909 -1.549,-7.572 -0.931,-0.616 -1.98,-0.911 -3.019,-0.911 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(819.5088,817.9746)",
    id: "g406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path408",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -2.786,6.35 -3.783,15.098"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(828.2324,825.4268)",
    id: "g410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path412",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -2.298,4.369 -1.448,11.138"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(891.5713,612.5444)",
    id: "g414"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path416",
    style: {
      fill: "#ff5235",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -5.298,2.597 -10.49,3.261 -12.698,2.323 -0.45,-0.19 -0.617,-0.262 -0.67,-1.082 -0.148,-2.174 0.642,-2.677 1.066,-2.947 2.073,-1.321 6.995,-1.268 11.331,1.121 C -0.674,-0.422 -0.345,-0.227 0,0 m -14.099,29.079 c 1.364,1.331 3.34,1.977 5.344,1.551 0.99,-0.21 24.244,-5.371 24.315,-24.923 0.003,-0.735 -0.042,-1.461 -0.131,-2.177 7.245,-6.915 10.253,-15.539 8.273,-23.958 -4.881,-20.758 -21.01,-27.009 -28.855,-27.411 -3.257,-0.168 -6.035,2.337 -6.201,5.593 -0.167,3.257 2.336,6.035 5.593,6.202 1.369,0.101 14.011,1.498 17.965,18.318 0.948,4.029 -0.647,7.557 -2.683,10.216 -1.383,-1.276 -2.986,-2.425 -4.792,-3.421 -7.87,-4.335 -17.263,-4.631 -23.376,-0.736 -4.594,2.926 -6.905,7.793 -6.506,13.702 0.344,5.121 3.202,9.19 7.836,11.159 5.313,2.258 12.088,1.501 18.433,-0.857 -4.266,4.908 -12.233,6.72 -12.343,6.744 -3.178,0.698 -5.203,3.836 -4.516,7.017 0.255,1.177 0.843,2.198 1.644,2.981"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(891.5713,612.5444)",
    id: "g418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path420",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -5.298,2.597 -10.49,3.261 -12.698,2.323 -0.45,-0.19 -0.617,-0.262 -0.67,-1.082 -0.148,-2.174 0.642,-2.677 1.066,-2.947 2.073,-1.321 6.995,-1.268 11.331,1.121 C -0.674,-0.422 -0.345,-0.227 0,0 Z m -14.099,29.079 c 1.364,1.331 3.34,1.977 5.344,1.551 0.99,-0.21 24.244,-5.371 24.315,-24.923 0.003,-0.735 -0.042,-1.461 -0.131,-2.177 7.245,-6.915 10.253,-15.539 8.273,-23.958 -4.881,-20.758 -21.01,-27.009 -28.855,-27.411 -3.257,-0.168 -6.035,2.337 -6.201,5.593 -0.167,3.257 2.336,6.035 5.593,6.202 1.369,0.101 14.011,1.498 17.965,18.318 0.948,4.029 -0.647,7.557 -2.683,10.216 -1.383,-1.276 -2.986,-2.425 -4.792,-3.421 -7.87,-4.335 -17.263,-4.631 -23.376,-0.736 -4.594,2.926 -6.905,7.793 -6.506,13.702 0.344,5.121 3.202,9.19 7.836,11.159 5.313,2.258 12.088,1.501 18.433,-0.857 -4.266,4.908 -12.233,6.72 -12.343,6.744 -3.178,0.698 -5.203,3.836 -4.516,7.017 0.255,1.177 0.843,2.198 1.644,2.981 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g422"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g436"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g434",
    clipPath: "url(#clipPath428)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g432",
    transform: "translate(886.1885,598.8823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path430",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 2.988,3.328 2.134,5.761 -0.855,2.432 -3.915,4.008 -3.915,4.008 0,0 6.109,2.314 6.572,2.463 0.464,0.148 1.916,0.073 1.916,0.073 0,0 3.762,-2.054 5.708,-3.314 1.946,-1.26 1.37,-3.932 1.37,-3.932 C 13.785,5.059 5.741,-0.27 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g438"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g440"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g452"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g450",
    clipPath: "url(#clipPath444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g448",
    transform: "translate(900.8184,632.8237)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path446",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -6.214,-5.179 -10.785,-4.07 l 1.57,-3.944 c 0,0 3.651,-1.114 4.257,-1.433 0.607,-0.318 7.553,-4.59 7.553,-4.59 l 3.178,0.024 c 0,0 0.663,8.3 -5.773,14.013"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g454"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g456"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g468"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g466",
    clipPath: "url(#clipPath460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g464",
    transform: "translate(894.2998,579.7075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path462",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -1.296,-7.511 5.141,-10.012 0,0 -5.825,-4.446 -10.233,-4.647 -4.408,-0.199 -7.654,0.701 -8.615,4.84 -0.962,4.14 3.107,6.516 6.055,6.713 C -4.706,-2.91 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(891.5713,612.5444)",
    id: "g470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path472",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c -5.298,2.597 -10.49,3.261 -12.698,2.323 -0.45,-0.19 -0.617,-0.262 -0.67,-1.082 -0.148,-2.174 0.642,-2.677 1.066,-2.947 2.073,-1.321 6.995,-1.268 11.331,1.121 C -0.674,-0.422 -0.345,-0.227 0,0 Z m -14.099,29.079 c 1.364,1.331 3.34,1.977 5.344,1.551 0.99,-0.21 24.244,-5.371 24.315,-24.923 0.003,-0.735 -0.042,-1.461 -0.131,-2.177 7.245,-6.915 10.253,-15.539 8.273,-23.958 -4.881,-20.758 -21.01,-27.009 -28.855,-27.411 -3.257,-0.168 -6.035,2.337 -6.201,5.593 -0.167,3.257 2.336,6.035 5.593,6.202 1.369,0.101 14.011,1.498 17.965,18.318 0.948,4.029 -0.647,7.557 -2.683,10.216 -1.383,-1.276 -2.986,-2.425 -4.792,-3.421 -7.87,-4.335 -17.263,-4.631 -23.376,-0.736 -4.594,2.926 -6.905,7.793 -6.506,13.702 0.344,5.121 3.202,9.19 7.836,11.159 5.313,2.258 12.088,1.501 18.433,-0.857 -4.266,4.908 -12.233,6.72 -12.343,6.744 -3.178,0.698 -5.203,3.836 -4.516,7.017 0.255,1.177 0.843,2.198 1.644,2.981 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(892.6875,624.8818)",
    id: "g474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path476",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 6.942,-2.802 14.313,-8.808"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(891.5713,612.5444)",
    id: "g478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path480",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 5.07,-1.641 9.521,-7.51"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(835.0645,285.4414)",
    id: "g482"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path484",
    style: {
      fill: "#ff5235",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -24.644,4.054 -25.185,28.748 l 12.089,1.355 c 0,0 1.536,-16.055 19.493,-17.694 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(835.0645,285.4414)",
    id: "g486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path488",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -24.644,4.054 -25.185,28.748 l 12.089,1.355 c 0,0 1.536,-16.055 19.493,-17.694 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(904.9385,370.334)",
    id: "g490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path492",
    style: {
      fill: "#ff5235",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 8.798,20.979 30.792,16.242 L 29.438,5.245 c 0,0 -14.549,2.03 -19.794,-13.535 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(904.9385,370.334)",
    id: "g494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path496",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 8.798,20.979 30.792,16.242 L 29.438,5.245 c 0,0 -14.549,2.03 -19.794,-13.535 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640.7021,842.3291)",
    id: "g498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path500",
    style: {
      fill: "#ff5235",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 27.459,3.467 35.822,-22.596 l -12.414,-5.252 c 0,0 -6.697,16.572 -26.29,12.647 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640.7021,842.3291)",
    id: "g502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path504",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 27.459,3.467 35.822,-22.596 l -12.414,-5.252 c 0,0 -6.697,16.572 -26.29,12.647 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(715.6514,764.0332)",
    id: "g506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path508",
    style: {
      fill: "#ffa3f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 18.497,-20.311 2.117,-41.986 l -11.354,7.079 c 0,0 9.628,14.9 -4.749,28.565 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(715.6514,764.0332)",
    id: "g510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path512",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 18.497,-20.311 2.117,-41.986 l -11.354,7.079 c 0,0 9.628,14.9 -4.749,28.565 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(900.6855,523.0903)",
    id: "g514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path516",
    style: {
      fill: "#ffa3f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 21.901,-7.592 18.504,-30.264 l -11.271,0.667 c 0,0 1.126,14.927 -15.041,19.255 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(900.6855,523.0903)",
    id: "g518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path520",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 21.901,-7.592 18.504,-30.264 l -11.271,0.667 c 0,0 1.126,14.927 -15.041,19.255 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735.5449,847.5806)",
    id: "g522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path524",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 25.551,-1.125 29.104,-26.169 l -12.127,-2.847 c 0,0 -3.515,16.138 -21.973,15.62 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735.5449,847.5806)",
    id: "g526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path528",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 25.551,-1.125 29.104,-26.169 l -12.127,-2.847 c 0,0 -3.515,16.138 -21.973,15.62 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(598.502,880.9272)",
    id: "g530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path532",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -10.389,18.874 6.069,32.404 l 7.364,-7.476 c 0,0 -10.07,-9.6 -1.607,-22.652 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(598.502,880.9272)",
    id: "g534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path536",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -10.389,18.874 6.069,32.404 l 7.364,-7.476 c 0,0 -10.07,-9.6 -1.607,-22.652 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(861.4648,440.9648)",
    id: "g538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path540",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -2.174,20.37 17.233,26.187 l 3.709,-9.262 c 0,0 -12.359,-4.719 -9.734,-19.276 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(861.4648,440.9648)",
    id: "g542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path544",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -2.174,20.37 17.233,26.187 l 3.709,-9.262 c 0,0 -12.359,-4.719 -9.734,-19.276 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(888.5127,714.8257)",
    id: "g546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path548",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 23.165,-1.02 26.386,-23.724 l -10.994,-2.581 c 0,0 -3.187,14.63 -19.921,14.16 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(888.5127,714.8257)",
    id: "g550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path552",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 23.165,-1.02 26.386,-23.724 l -10.994,-2.581 c 0,0 -3.187,14.63 -19.921,14.16 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(836.2744,897.1294)",
    id: "g554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path556",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -14.018,21.504 4.339,39.042 l 9.412,-8.23 c 0,0 -11.113,-12.301 0.1,-27.059 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(836.2744,897.1294)",
    id: "g558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path560",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -14.018,21.504 4.339,39.042 l 9.412,-8.23 c 0,0 -11.113,-12.301 0.1,-27.059 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(750.6748,374.8555)",
    id: "g562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path564",
    style: {
      fill: "#47ecff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -13.29,-21.099 -36.217,-12.015 l 3.445,11.647 c 0,0 15.365,-4.817 23.839,11.068 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(750.6748,374.8555)",
    id: "g566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path568",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -13.29,-21.099 -36.217,-12.015 l 3.445,11.647 c 0,0 15.365,-4.817 23.839,11.068 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(894.9102,776.5176)",
    id: "g570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path572",
    style: {
      fill: "#ffdb48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 19.374,-0.854 22.067,-19.842 l -9.195,-2.159 c 0,0 -2.665,12.236 -16.661,11.843 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(894.9102,776.5176)",
    id: "g574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path576",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 19.374,-0.854 22.067,-19.842 l -9.195,-2.159 c 0,0 -2.665,12.236 -16.661,11.843 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(697.8408,923.2041)",
    id: "g578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path580",
    style: {
      fill: "#ffdb48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 24.986,-1.1 28.46,-25.589 l -11.858,-2.785 c 0,0 -3.437,15.781 -21.488,15.274 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(697.8408,923.2041)",
    id: "g582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path584",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 24.986,-1.1 28.46,-25.589 l -11.858,-2.785 c 0,0 -3.437,15.781 -21.488,15.274 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(855.1816,527.9077)",
    id: "g586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path588",
    style: {
      fill: "#ffdb48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -8.24,-24.733 -33.782,-21.22 l 0.596,12.683 c 0,0 16.802,-1.063 21.45,17.177 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(855.1816,527.9077)",
    id: "g590"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path592",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -8.24,-24.733 -33.782,-21.22 l 0.596,12.683 c 0,0 16.802,-1.063 21.45,17.177 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(804.1992,436.1152)",
    id: "g594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path596",
    style: {
      fill: "#ffdb48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 22.045,-12.549 13.855,-36.262 L 1.863,-33.29 c 0,0 4.197,15.835 -12.332,23.726 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(804.1992,436.1152)",
    id: "g598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path600",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 22.045,-12.549 13.855,-36.262 L 1.863,-33.29 c 0,0 4.197,15.835 -12.332,23.726 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.8218,260.7236)",
    id: "g602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path604",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 213.811 c 15.628,0 28.297,12.669 28.297,28.297 l 9.85,206.193 c 0,15.628 -12.67,28.297 -28.298,28.297 H -9.849 c -15.629,0 -28.297,-12.669 -28.297,-28.297 L -28.297,28.297 C -28.297,12.669 -15.628,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g606"
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "g608"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g620"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g618",
    clipPath: "url(#clipPath612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g616",
    transform: "translate(397.0269,269.5791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path614",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 199.401 c 14.574,0 26.39,9.622 26.39,21.49 l 9.185,156.597 c 0,11.869 -11.815,21.49 -26.39,21.49 H -9.186 c -14.574,0 -26.39,-9.621 -26.39,-21.49 L -26.39,21.49 C -26.39,9.622 -14.575,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.8218,260.7236)",
    id: "g622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path624",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h 213.811 c 15.628,0 28.297,12.669 28.297,28.297 l 9.85,206.193 c 0,15.628 -12.67,28.297 -28.298,28.297 H -9.849 c -15.629,0 -28.297,-12.669 -28.297,-28.297 L -28.297,28.297 C -28.297,12.669 -15.628,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g626"
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g628"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g638",
    clipPath: "url(#clipPath632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g636",
    transform: "translate(242.8081,73.8906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path634",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,-18.993 113.684,-34.391 253.919,-34.391 140.236,0 253.919,15.398 253.919,34.391 0,18.993 -113.683,34.391 -253.919,34.391 C 113.684,34.391 0,18.993 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496.7271,536.4868)",
    id: "g642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path644",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 82.254,12.732 114.041,-64.525 7.611,-18.501 4.43,-141.676 -7.416,-164.904 C 82.98,-275.787 41.491,-289.014 0,-289.014 c -41.49,0 -82.98,13.227 -106.624,59.585 -11.847,23.228 -15.028,146.403 -7.416,164.904 C -82.255,12.732 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g646"
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "g648"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g660"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g658",
    clipPath: "url(#clipPath652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g656",
    transform: "translate(603.3516,335.1553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path654",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -23.645,-46.357 -65.134,-59.585 -106.624,-59.586 -41.49,0 -82.98,13.229 -106.625,59.586 -6.688,13.114 -10.614,58.084 -11.395,98.09 -0.985,-44.028 3.06,-109.845 11.395,-126.187 23.645,-46.358 65.135,-59.586 106.625,-59.586 41.49,0 82.979,13.228 106.624,59.586 C 8.335,-11.755 12.38,54.061 11.395,98.089 10.613,58.083 6.688,13.114 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(496.7271,536.4868)",
    id: "g662"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path664",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 75.012,11.611 109.451,-54.625 10.259,-19.734 9.02,-151.576 -2.826,-174.804 C 83.26,-275.238 42.47,-287.04 1.474,-287.583 c -41.979,-0.554 -84.174,11.248 -108.098,58.154 -11.847,23.228 -13.086,155.071 -2.826,174.805 C -75.012,11.611 0,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679.4385,534.6055)",
    id: "g666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path668",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 0.002 C -17.749,-12.877 -39.52,-24.989 -64.063,-31.155 L -82.2,-57.521 -72.097,-87.117 c 2.796,-14.488 5.784,-43.901 5.784,-43.901 0,0 58.583,12.28 112.336,61.012 C 10.118,-57.151 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(790.4492,596.9316)",
    id: "g670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path672",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -11.281,11.002 -32.912,4.209 -32.912,4.209 0,0 -11.71,7.02 -19.316,2.669 -7.605,-4.351 -9.352,-22.248 -9.352,-22.248 0,0 -18.669,-24.631 -49.431,-46.954 v -0.002 c 0,0 10.118,-57.152 46.024,-70.006 15.198,13.778 30.01,30.467 43.004,50.62 0,0 22.958,14.337 29.672,29.278 C 14.404,-37.492 11.281,-11.002 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g674"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "g676"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g688"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g686",
    clipPath: "url(#clipPath680)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g684",
    transform: "translate(681.6016,525.3975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path682",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 18.387,13.275 34.78,30.051 16.395,16.775 19.318,21.78 19.826,23.027 0.508,1.246 2.288,16.242 7.498,18.403 5.21,2.161 17.423,-4.676 20.334,-12.835 0,0 1.538,0 2.293,1.27 0.757,1.271 0,6.481 0,6.481 v 1.525 c 0,0 12.576,4.449 22.235,-5.591 9.658,-10.04 13.079,-32.407 13.079,-32.407 0,0 1.663,20.715 -4.565,32.534 -6.227,11.819 -18.045,16.013 -26.306,15.504 -8.261,-0.508 -12.2,-1.906 -12.2,-1.906 0,0 -16.161,8.088 -22.632,0.486 -6.472,-7.603 -6.98,-21.739 -6.98,-21.739 0,0 -18.757,-20.446 -29.521,-29.462 C 7.075,16.325 -2.163,8.51 -2.163,8.51 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g690"
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "g692"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g704"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g702",
    clipPath: "url(#clipPath696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g700",
    transform: "translate(612.1445,430.5225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path698",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 54.293,13.725 100.807,48.038 46.513,34.314 48.165,57.062 47.657,59.604 -0.509,2.542 -13.472,19.825 -6.863,37.618 l 3.813,4.115 4.698,1.032 3.12,1.732 0.956,2.652 c 0,0 -1.531,-17.633 10.002,-25.068 11.534,-7.434 24.116,1.144 24.116,1.144 0,0 2.096,-12.486 -6.673,-23.733 -8.769,-11.247 -25.312,-22.436 -25.312,-22.436 0,0 -19.153,-32.545 -56.015,-61.672 C 63.442,-6.101 29.635,-17.733 29.635,-17.733 L 4.348,-26.935 c 0,0 -3.018,1.295 -3.368,1.676 -0.35,0.381 -1.214,21.93 -1.214,21.93 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(707.3857,449.625)",
    id: "g706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path708",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -42.293,12.113 -34.66,-22.349 -34.66,-22.349 l 17.061,10.082 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(593.9424,479.3506)",
    id: "g710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path712",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 18.103,26.391 c 0.57,0.832 1.397,1.382 2.302,1.619 l 0.043,0.011 c 10.99,2.856 21.716,6.84 31.94,11.929 2.58,1.221 5.081,2.608 7.608,3.939 2.48,1.422 4.994,2.784 7.42,4.305 4.909,2.941 9.672,6.135 14.334,9.473 4.669,3.328 9.209,6.845 13.624,10.517 4.42,3.666 8.737,7.461 12.922,11.4 4.186,3.937 8.246,8.012 12.166,12.207 1.963,2.095 3.884,4.227 5.761,6.389 1.859,2.144 3.747,4.39 5.406,6.53 l -0.819,-2.096 c 0.235,2.135 0.551,4.01 0.955,5.995 0.402,1.959 0.885,3.912 1.497,5.867 0.608,1.954 1.343,3.91 2.317,5.862 0.986,1.942 2.189,3.919 4.05,5.727 0.457,0.452 0.986,0.877 1.531,1.287 0.582,0.397 1.186,0.775 1.776,1.058 1.195,0.594 2.45,1.003 3.688,1.254 2.488,0.5 4.858,0.384 7.064,0.051 2.208,-0.348 4.268,-0.951 6.241,-1.684 0.985,-0.369 1.948,-0.774 2.895,-1.213 0.473,-0.222 0.944,-0.448 1.412,-0.691 0.489,-0.253 0.896,-0.466 1.475,-0.806 l -3.351,0.397 c 0.857,0.259 1.515,0.426 2.261,0.608 0.726,0.173 1.448,0.337 2.174,0.48 1.449,0.293 2.906,0.532 4.376,0.718 2.936,0.376 5.926,0.536 8.962,0.399 3.033,-0.143 6.124,-0.595 9.177,-1.544 1.524,-0.479 3.029,-1.104 4.493,-1.848 1.454,-0.774 2.854,-1.69 4.156,-2.749 2.586,-2.192 4.557,-4.68 6.172,-7.327 1.611,-2.641 2.892,-5.396 3.901,-8.204 2.019,-5.618 3.155,-11.413 3.574,-17.254 0.396,-5.843 0.165,-11.753 -1.137,-17.632 -0.656,-2.934 -1.564,-5.871 -2.95,-8.713 -1.371,-2.843 -3.077,-5.351 -4.9,-7.692 -3.662,-4.673 -7.843,-8.648 -12.186,-12.349 -2.18,-1.841 -4.411,-3.602 -6.692,-5.293 -2.302,-1.699 -4.562,-3.293 -7.068,-4.891 l 1.262,1.243 C 173.432,26.717 168.6,19.976 163.467,13.474 158.314,6.987 152.859,0.74 147.118,-5.229 135.633,-17.166 123.003,-27.981 109.527,-37.582 96.045,-47.173 81.739,-55.604 66.762,-62.615 c -7.486,-3.51 -15.11,-6.729 -22.895,-9.535 -3.899,-1.386 -7.832,-2.68 -11.806,-3.865 -1.987,-0.594 -3.985,-1.157 -6,-1.674 -2.036,-0.524 -4,-1.005 -6.171,-1.448 l -0.072,-0.014 c -1.841,-0.375 -3.638,0.813 -4.013,2.655 -0.043,0.211 -0.065,0.44 -0.069,0.648 -0.031,3.531 -0.115,7.112 -0.222,10.667 -0.085,3.562 -0.228,7.121 -0.356,10.677 -0.159,3.554 -0.259,7.112 -0.492,10.65 -0.238,3.534 -0.442,7.074 -0.842,10.552 l -0.006,0.047 c -0.119,1.042 0.628,1.984 1.67,2.104 0.961,0.11 1.837,-0.517 2.062,-1.432 l 0.66,-2.676 0.559,-2.681 c 0.356,-1.788 0.684,-3.581 0.935,-5.373 0.545,-3.588 1.026,-7.173 1.383,-10.767 0.391,-3.592 0.661,-7.188 0.926,-10.783 0.238,-3.603 0.451,-7.182 0.615,-10.815 l -4.152,3.288 c 1.809,0.438 3.79,0.993 5.683,1.556 1.912,0.572 3.823,1.169 5.729,1.789 3.809,1.243 7.591,2.596 11.34,4.037 7.511,2.844 14.912,6.007 22.154,9.497 14.47,7.005 28.414,15.118 41.484,24.468 13.076,9.334 25.315,19.834 36.433,31.411 5.557,5.788 10.836,11.844 15.82,18.13 4.965,6.302 9.638,12.833 13.993,19.57 0.325,0.502 0.741,0.909 1.211,1.213 l 0.051,0.031 c 2.143,1.37 4.395,2.952 6.526,4.532 2.149,1.594 4.246,3.254 6.278,4.973 4.044,3.445 7.882,7.135 11.019,11.157 1.565,2.006 2.962,4.095 3.981,6.228 1.038,2.118 1.78,4.483 2.322,6.927 1.09,4.899 1.31,10.128 0.951,15.276 -0.369,5.154 -1.396,10.282 -3.114,15.043 -0.856,2.382 -1.927,4.646 -3.19,6.712 -1.242,2.062 -2.788,3.918 -4.411,5.293 -3.319,2.769 -8.045,4.046 -12.981,4.259 -2.475,0.109 -5.012,-0.022 -7.544,-0.349 -1.266,-0.161 -2.531,-0.37 -3.784,-0.624 -0.628,-0.124 -1.249,-0.267 -1.865,-0.413 -0.594,-0.144 -1.27,-0.324 -1.734,-0.465 -1.164,-0.353 -2.377,-0.169 -3.351,0.397 -0.232,0.137 -0.655,0.366 -1.002,0.543 -0.367,0.189 -0.744,0.37 -1.122,0.547 -0.759,0.351 -1.532,0.675 -2.308,0.964 -1.551,0.576 -3.122,1.023 -4.632,1.258 -1.503,0.229 -2.953,0.26 -4.159,0.007 -0.604,-0.125 -1.148,-0.31 -1.637,-0.553 -0.262,-0.121 -0.445,-0.256 -0.647,-0.379 -0.201,-0.164 -0.412,-0.319 -0.621,-0.532 -0.851,-0.811 -1.684,-2.066 -2.385,-3.474 -0.705,-1.414 -1.307,-2.988 -1.813,-4.624 -0.509,-1.636 -0.932,-3.337 -1.285,-5.063 -0.348,-1.699 -0.645,-3.538 -0.821,-5.142 l -0.01,-0.091 c -0.083,-0.753 -0.38,-1.447 -0.81,-2.006 -1.914,-2.473 -3.787,-4.692 -5.746,-6.96 -1.946,-2.246 -3.929,-4.452 -5.955,-6.616 -4.043,-4.336 -8.221,-8.536 -12.533,-12.598 C 105.36,65.428 96.243,57.812 86.558,50.943 81.723,47.501 76.775,44.203 71.666,41.157 69.142,39.586 66.52,38.171 63.934,36.7 61.296,35.317 58.687,33.881 55.988,32.61 45.301,27.328 34.026,23.16 22.418,20.18 L 24.764,21.809 6.592,-4.534 C 5.337,-6.353 2.846,-6.81 1.027,-5.556 -0.791,-4.301 -1.254,-1.818 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(679.4385,534.6055)",
    id: "g714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path716",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 10.118,-57.154 46.025,-70.007"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759.6582,604.5312)",
    id: "g718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path720",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 0.758,-0.467 1.4,-0.896 c 0.419,-0.286 0.823,-0.582 1.211,-0.896 0.777,-0.627 1.533,-1.281 2.235,-2.003 1.407,-1.435 2.692,-3.057 3.719,-4.91 0.513,-0.924 0.976,-1.896 1.353,-2.914 0.364,-1.025 0.646,-2.089 0.849,-3.175 0.185,-1.09 0.285,-2.197 0.288,-3.302 -0.018,-0.55 -0.035,-1.104 -0.097,-1.647 l -0.096,-0.815 c -0.007,-0.089 -0.059,-0.397 -0.103,-0.615 -0.042,-0.234 -0.116,-0.477 -0.184,-0.712 -0.288,-0.951 -0.796,-1.863 -1.392,-2.576 -0.597,-0.723 -1.258,-1.268 -1.894,-1.688 -1.28,-0.83 -2.464,-1.254 -3.562,-1.538 -2.2,-0.554 -4.144,-0.659 -6.043,-0.688 -1.886,0.018 -3.733,-0.061 -5.484,0.721 -0.871,0.39 -1.724,0.802 -2.562,1.234 -0.843,0.421 -1.658,0.898 -2.431,1.719 -0.515,0.546 -0.488,1.405 0.058,1.92 0.066,0.062 0.137,0.117 0.213,0.164 l 0.082,0.051 c 0.903,0.556 1.773,0.819 2.618,1.053 0.848,0.246 1.686,0.505 2.508,0.776 1.635,0.547 3.187,0.363 4.694,0.505 1.488,0.107 2.95,0.329 4.025,0.693 0.531,0.178 0.947,0.385 1.08,0.5 0.068,0.054 0.056,0.07 -0.005,0.006 -0.057,-0.058 -0.155,-0.208 -0.203,-0.344 -0.016,-0.03 -0.016,-0.072 -0.029,-0.095 -0.01,-0.009 -0.015,-0.111 -0.007,0.013 l 0.033,0.452 c 0.025,0.3 0.014,0.598 0.016,0.895 -0.007,0.593 -0.065,1.18 -0.165,1.764 -0.225,1.164 -0.639,2.315 -1.226,3.454 -0.602,1.128 -1.37,2.243 -2.274,3.291 -0.456,0.52 -0.928,1.041 -1.436,1.525 l -0.76,0.712 -0.672,0.584 -0.454,0.395 C -6.355,-4.946 -6.531,-2.434 -5.09,-0.776 -3.793,0.716 -1.629,1.007 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(759.7363,579.4702)",
    id: "g722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path724",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.07,-0.955 -0.093,-2.157 -0.107,-3.253 -0.021,-1.122 0.009,-2.247 0.044,-3.368 0.077,-2.243 0.279,-4.47 0.598,-6.647 0.342,-2.172 0.812,-4.296 1.475,-6.3 0.678,-1.998 1.551,-3.871 2.657,-5.512 2.21,-3.29 5.599,-5.398 9.767,-6.111 4.179,-0.627 8.743,-0.365 13.783,-0.394 0.194,-10e-4 0.35,-0.159 0.35,-0.353 -0.001,-0.113 -0.056,-0.215 -0.138,-0.279 -4.051,-3.085 -9.131,-4.719 -14.562,-4.505 -2.705,0.163 -5.503,0.76 -8.102,2.01 -2.61,1.228 -4.903,3.146 -6.698,5.329 -1.817,2.184 -3.159,4.636 -4.171,7.134 -1.025,2.499 -1.734,5.058 -2.215,7.621 -0.501,2.561 -0.762,5.13 -0.878,7.691 -0.064,1.281 -0.057,2.561 -0.029,3.843 0.031,1.308 0.118,2.51 0.272,3.948 0.235,2.196 2.206,3.786 4.402,3.55 2.15,-0.23 3.718,-2.123 3.563,-4.262 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(672.7256,427.2764)",
    id: "g726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path728",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -7.633,34.462 34.66,22.349"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.0215,534.6055)",
    id: "g730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path732",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 0.002 C 17.749,-12.877 39.52,-24.989 64.063,-31.155 L 82.2,-57.521 72.097,-87.117 c -2.796,-14.488 -5.783,-43.901 -5.783,-43.901 0,0 -58.583,12.28 -112.337,61.012 C -10.118,-57.151 0,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.0107,596.9316)",
    id: "g734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path736",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 11.281,11.002 32.913,4.209 32.913,4.209 0,0 11.709,7.02 19.315,2.669 7.605,-4.351 9.352,-22.248 9.352,-22.248 0,0 18.669,-24.631 49.431,-46.954 v -0.002 c 0,0 -10.118,-57.152 -46.023,-70.006 -15.198,13.778 -30.011,30.467 -43.004,50.62 0,0 -22.959,14.337 -29.673,29.278 C -14.404,-37.492 -11.281,-11.002 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g738"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "g740"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g752"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g750",
    clipPath: "url(#clipPath744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g748",
    transform: "translate(311.8584,525.3975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path746",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -18.386,13.275 -34.78,30.051 -16.394,16.775 -19.317,21.78 -19.825,23.027 -0.509,1.246 -2.288,16.242 -7.499,18.403 -5.21,2.161 -17.423,-4.676 -20.334,-12.835 0,0 -1.537,0 -2.293,1.27 -0.757,1.271 0,6.481 0,6.481 v 1.525 c 0,0 -12.576,4.449 -22.234,-5.591 -9.659,-10.04 -13.079,-32.407 -13.079,-32.407 0,0 -1.664,20.715 4.564,32.534 6.227,11.819 18.046,16.013 26.307,15.504 8.26,-0.508 12.2,-1.906 12.2,-1.906 0,0 16.16,8.088 22.632,0.486 6.471,-7.603 6.979,-21.739 6.979,-21.739 0,0 18.757,-20.446 29.522,-29.462 C -7.075,16.325 2.163,8.51 2.163,8.51 Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g754"
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "g756"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g768"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g766",
    clipPath: "url(#clipPath760)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g764",
    transform: "translate(381.3159,430.5225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path762",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -54.292,13.725 -100.806,48.038 -46.514,34.314 -48.166,57.062 -47.658,59.604 0.508,2.542 13.471,19.825 6.863,37.618 l -3.813,4.115 -4.699,1.032 -3.119,1.732 -0.957,2.652 c 0,0 1.531,-17.633 -10.002,-25.068 -11.533,-7.434 -24.115,1.144 -24.115,1.144 0,0 -2.096,-12.486 6.673,-23.733 8.769,-11.247 25.312,-22.436 25.312,-22.436 0,0 19.153,-32.545 56.015,-61.672 36.863,-29.127 70.671,-40.759 70.671,-40.759 l 25.287,-9.202 c 0,0 3.017,1.295 3.368,1.676 0.35,0.381 1.214,21.93 1.214,21.93 z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.0747,449.625)",
    id: "g770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path772",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 42.293,12.113 34.66,-22.349 34.66,-22.349 L 17.599,-12.267 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(392.9263,474.8164)",
    id: "g774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path776",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -18.172,26.343 2.345,-1.629 c -11.607,2.98 -22.881,7.148 -33.569,12.431 -2.699,1.271 -5.308,2.706 -7.946,4.089 -2.586,1.471 -5.208,2.886 -7.732,4.457 -5.11,3.046 -10.057,6.344 -14.891,9.787 -9.687,6.868 -18.804,14.484 -27.435,22.595 -4.311,4.062 -8.49,8.262 -12.533,12.598 -2.025,2.164 -4.008,4.37 -5.955,6.617 -1.959,2.267 -3.831,4.486 -5.745,6.959 -0.464,0.599 -0.73,1.289 -0.809,1.99 l -0.011,0.107 c -0.176,1.604 -0.473,3.444 -0.821,5.142 -0.353,1.726 -0.775,3.428 -1.286,5.063 -0.505,1.637 -1.107,3.21 -1.813,4.624 -0.7,1.408 -1.533,2.663 -2.384,3.474 -0.209,0.213 -0.42,0.368 -0.621,0.532 -0.202,0.123 -0.386,0.259 -0.647,0.38 -0.49,0.242 -1.034,0.427 -1.638,0.552 -1.206,0.253 -2.655,0.222 -4.159,-0.007 -1.509,-0.234 -3.081,-0.682 -4.632,-1.258 -0.775,-0.289 -1.548,-0.613 -2.307,-0.964 -0.379,-0.177 -0.756,-0.358 -1.122,-0.547 -0.347,-0.177 -0.771,-0.406 -1.002,-0.543 -1.049,-0.615 -2.272,-0.719 -3.351,-0.396 -0.464,0.14 -1.14,0.32 -1.734,0.464 -0.616,0.146 -1.238,0.289 -1.865,0.413 -1.253,0.254 -2.519,0.463 -3.784,0.624 -2.532,0.328 -5.07,0.458 -7.545,0.349 -4.936,-0.213 -9.662,-1.49 -12.981,-4.259 -1.623,-1.375 -3.168,-3.231 -4.411,-5.293 -1.262,-2.066 -2.334,-4.33 -3.189,-6.712 -1.718,-4.761 -2.746,-9.889 -3.115,-15.043 -0.358,-5.147 -0.138,-10.376 0.952,-15.275 0.541,-2.445 1.284,-4.81 2.322,-6.928 1.019,-2.132 2.416,-4.222 3.98,-6.228 3.138,-4.022 6.976,-7.712 11.02,-11.156 2.031,-1.72 4.129,-3.379 6.277,-4.974 2.132,-1.58 4.384,-3.162 6.527,-4.532 l 0.032,-0.02 c 0.504,-0.322 0.923,-0.753 1.229,-1.223 4.356,-6.738 9.029,-13.269 13.994,-19.571 4.984,-6.286 10.262,-12.342 15.819,-18.13 11.119,-11.577 23.357,-22.077 36.434,-31.411 13.069,-9.349 27.014,-17.463 41.483,-24.468 7.243,-3.49 14.643,-6.653 22.155,-9.497 3.748,-1.441 7.53,-2.794 11.34,-4.037 1.905,-0.62 3.817,-1.217 5.729,-1.789 1.893,-0.563 3.873,-1.118 5.683,-1.555 l -4.153,-3.289 c 0.164,3.633 0.377,7.212 0.616,10.815 0.265,3.596 0.535,7.191 0.925,10.783 0.357,3.594 0.838,7.179 1.383,10.767 0.252,1.793 0.579,3.586 0.936,5.373 l 0.559,2.681 0.66,2.676 c 0.251,1.019 1.28,1.641 2.299,1.389 0.939,-0.232 1.541,-1.124 1.432,-2.061 l -0.005,-0.047 c -0.4,-3.478 -0.604,-7.018 -0.843,-10.552 -0.233,-3.537 -0.333,-7.096 -0.492,-10.65 -0.127,-3.555 -0.27,-7.115 -0.355,-10.676 -0.108,-3.556 -0.191,-7.137 -0.223,-10.667 -0.017,-1.88 -1.554,-3.389 -3.433,-3.373 -0.215,0.002 -0.426,0.025 -0.63,0.065 l -0.09,0.018 c -2.171,0.443 -4.136,0.924 -6.171,1.448 -2.016,0.517 -4.014,1.08 -6,1.675 -3.974,1.184 -7.907,2.478 -11.806,3.864 -7.786,2.806 -15.41,6.025 -22.895,9.535 -14.978,7.011 -29.284,15.442 -42.766,25.033 -13.475,9.601 -26.106,20.416 -37.591,32.354 -5.741,5.968 -11.196,12.215 -16.348,18.702 -5.133,6.502 -9.965,13.243 -14.468,20.197 l 1.261,-1.244 c -2.505,1.599 -4.765,3.192 -7.067,4.892 -2.282,1.69 -4.513,3.451 -6.692,5.293 -4.344,3.7 -8.524,7.675 -12.186,12.349 -1.824,2.34 -3.53,4.848 -4.9,7.692 -1.386,2.841 -2.295,5.778 -2.949,8.712 -1.303,5.879 -1.534,11.789 -1.139,17.632 0.42,5.842 1.556,11.636 3.574,17.255 1.009,2.807 2.291,5.562 3.902,8.203 1.615,2.647 3.586,5.135 6.172,7.327 1.302,1.059 2.701,1.975 4.156,2.749 1.463,0.745 2.968,1.369 4.493,1.848 3.053,0.949 6.143,1.401 9.177,1.545 3.036,0.136 6.025,-0.024 8.962,-0.399 1.47,-0.186 2.927,-0.426 4.376,-0.719 0.725,-0.143 1.448,-0.307 2.173,-0.48 0.746,-0.182 1.405,-0.349 2.261,-0.608 l -3.351,-0.397 c 0.579,0.34 0.987,0.553 1.475,0.807 0.469,0.242 0.939,0.468 1.413,0.69 0.947,0.44 1.909,0.844 2.895,1.213 1.972,0.733 4.032,1.336 6.24,1.685 2.206,0.333 4.576,0.448 7.065,-0.052 1.238,-0.251 2.493,-0.66 3.688,-1.254 0.59,-0.282 1.194,-0.661 1.776,-1.058 0.545,-0.409 1.074,-0.835 1.531,-1.287 1.861,-1.808 3.063,-3.785 4.05,-5.726 0.973,-1.953 1.708,-3.909 2.317,-5.863 0.611,-1.954 1.095,-3.907 1.497,-5.866 0.403,-1.986 0.719,-3.861 0.955,-5.996 l -0.82,2.097 c 1.66,-2.141 3.548,-4.387 5.407,-6.531 1.877,-2.162 3.798,-4.294 5.761,-6.389 3.92,-4.195 7.979,-8.269 12.165,-12.206 4.185,-3.94 8.502,-7.735 12.922,-11.401 4.415,-3.672 8.956,-7.189 13.625,-10.517 4.661,-3.338 9.425,-6.532 14.333,-9.473 2.427,-1.521 4.941,-2.883 7.421,-4.305 2.527,-1.331 5.028,-2.718 7.608,-3.939 10.223,-5.088 20.949,-9.073 31.939,-11.929 l 0.038,-0.01 c 0.975,-0.253 1.778,-0.849 2.308,-1.62 L 6.591,4.534 C 7.841,2.712 7.377,0.223 5.555,-1.027 3.733,-2.276 1.25,-1.821 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.0215,534.6055)",
    id: "g778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path780",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -10.118,-57.154 -46.025,-70.007"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.0454,597.7495)",
    id: "g782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path784",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 -0.672,-0.584 -1.433,-1.296 C -1.94,-1.78 -2.412,-2.301 -2.869,-2.821 -3.772,-3.869 -4.54,-4.984 -5.142,-6.112 c -0.587,-1.139 -1.002,-2.29 -1.227,-3.454 -0.099,-0.584 -0.157,-1.171 -0.164,-1.764 0.002,-0.297 -0.009,-0.595 0.015,-0.896 l 0.033,-0.451 c 0.008,-0.124 0.003,-0.023 -0.006,-0.013 -0.013,0.023 -0.013,0.065 -0.03,0.094 -0.048,0.137 -0.145,0.286 -0.203,0.345 -0.06,0.063 -0.072,0.048 -0.005,-0.006 0.134,-0.115 0.55,-0.323 1.081,-0.5 1.074,-0.365 2.537,-0.586 4.024,-0.694 1.507,-0.141 3.059,0.042 4.695,-0.505 0.821,-0.271 1.659,-0.529 2.508,-0.775 0.845,-0.234 1.714,-0.498 2.618,-1.054 l 0.076,-0.047 c 0.639,-0.393 0.838,-1.23 0.444,-1.869 -0.048,-0.077 -0.107,-0.154 -0.167,-0.218 -0.774,-0.822 -1.589,-1.298 -2.43,-1.72 -0.839,-0.431 -1.692,-0.843 -2.564,-1.234 -1.751,-0.781 -3.597,-0.703 -5.483,-0.721 -1.9,0.03 -3.844,0.135 -6.042,0.689 -1.1,0.284 -2.283,0.708 -3.564,1.538 -0.635,0.42 -1.296,0.965 -1.893,1.687 -0.596,0.714 -1.104,1.626 -1.393,2.576 -0.067,0.236 -0.141,0.479 -0.183,0.712 -0.044,0.219 -0.097,0.527 -0.103,0.616 l -0.097,0.815 c -0.061,0.543 -0.078,1.096 -0.096,1.647 0.003,1.105 0.103,2.212 0.288,3.302 0.202,1.085 0.485,2.15 0.848,3.175 0.378,1.018 0.841,1.989 1.353,2.914 1.028,1.853 2.312,3.475 3.72,4.91 0.702,0.721 1.458,1.376 2.235,2.002 0.388,0.315 0.791,0.611 1.21,0.897 l 0.643,0.428 0.757,0.468 C -2.374,7.935 0.077,7.354 1.23,5.485 2.268,3.802 1.901,1.649 0.455,0.395 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.6777,580.3242)",
    id: "g786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path788",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0.154,-1.438 0.242,-2.64 0.272,-3.948 0.301,-5.23 0.307,-6.51 0.244,-7.791 c -0.117,-2.561 -0.378,-5.13 -0.879,-7.691 -0.481,-2.563 -1.19,-5.122 -2.215,-7.621 -1.012,-2.498 -2.354,-4.95 -4.171,-7.134 -1.795,-2.183 -4.088,-4.101 -6.697,-5.329 -2.6,-1.25 -5.398,-1.847 -8.103,-2.01 -5.43,-0.214 -10.511,1.42 -14.561,4.505 -0.155,0.118 -0.185,0.338 -0.067,0.493 0.068,0.09 0.174,0.137 0.279,0.139 5.039,0.029 9.603,-0.233 13.782,0.394 4.169,0.713 7.557,2.821 9.767,6.111 1.107,1.641 1.979,3.514 2.657,5.512 0.664,2.004 1.133,4.128 1.475,6.3 0.319,2.177 0.521,4.404 0.598,6.647 0.035,1.121 0.065,2.246 0.044,3.368 -0.014,1.096 -0.037,2.298 -0.107,3.253 l -0.01,0.134 C -8.126,1.483 -6.472,3.4 -4.27,3.562 -2.114,3.721 -0.231,2.132 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.7349,427.2764)",
    id: "g790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path792",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 7.633,34.462 -34.66,22.349"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(609.7148,348.4932)",
    id: "g794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path796",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 H -35.272 V 19.082 H 0 c 5.269,0 9.541,-4.271 9.541,-9.541 C 9.541,4.272 5.269,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(609.7148,348.4932)",
    id: "g798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path800",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 H -35.272 V 19.082 H 0 c 5.269,0 9.541,-4.271 9.541,-9.541 C 9.541,4.272 5.269,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.9023,348.4932)",
    id: "g802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path804",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -35.407 c -5.269,0 -9.541,4.272 -9.541,9.541 0,5.27 4.272,9.541 9.541,9.541 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.9023,348.4932)",
    id: "g806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path808",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -35.407 c -5.269,0 -9.541,4.272 -9.541,9.541 0,5.27 4.272,9.541 9.541,9.541 H 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(604.8721,160.1084)",
    id: "g810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path812",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 3.077,61.395 -0.98,117.387 -3.332,142.625 -0.881,9.457 7.524,19.031 10.604,27.721 l -44.328,-55.305 c -23.151,-25.265 -60.77,-37.505 -60.77,-37.505 6.534,-30.847 9.468,-58.785 10.722,-81.347 0,0 50.087,20.574 87.104,3.811"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(634.7686,89.3281)",
    id: "g814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path816",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -2.683,31.605 -32.282,37.466 -32.282,37.466 1.057,11.18 1.835,22.334 2.386,33.314 -37.017,16.763 -87.105,-3.81 -87.105,-3.81 1.519,-27.345 0.568,-46.788 0.568,-53.925 0,-13.024 11.345,-32.562 24.862,-32.562 h 77.489 C -5.764,-19.517 0.888,-10.461 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g818"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "g820"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g832"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    },
    id: "g830",
    clipPath: "url(#clipPath824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g828",
    transform: "translate(552.1006,163.4248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path826",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 35.293,-4.07 40.228,-6.105 4.934,-2.036 2.467,-29.441 2.467,-29.441 0,0 3.754,-0.407 4.613,0 0.858,0.407 3.432,2.307 3.432,2.307 0,0 2.239,26.862 2.031,27.134 -0.207,0.271 -2.385,3.813 -2.385,3.813 0,0 -2.005,5.284 -24.426,5.552 C 3.54,3.527 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544.6514,257.0146)",
    id: "g834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path836",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -0.597,-26.686 2.837,-56.882 l -31.799,-17.69 c 0,0 -2.103,18.818 -4.073,30.731 -1.969,11.913 -4.57,36.16 -4.57,36.16 L -8.578,-3.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g838"
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "g840"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g852"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g850",
    clipPath: "url(#clipPath844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g848",
    transform: "translate(605.9814,241.5713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path846",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 -0.816,11.583 -1.719,24.33 -1.313,17.137 -0.948,9.348 -0.658,1.082 -0.225,0.406 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g854"
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "g856"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g868"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g866",
    clipPath: "url(#clipPath860)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g864",
    transform: "translate(612.1445,330.4541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path862",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -44.328,-55.305 c -23.151,-25.264 -60.771,-25.815 -60.771,-25.815 6.535,-30.847 9.468,-70.475 10.722,-93.036 1.519,-27.345 0.568,-46.788 0.568,-53.925 0,-13.024 11.345,-32.562 24.862,-32.562 H 8.542 c 8.318,0 14.97,9.056 14.082,19.517 -0.35,4.112 -1.162,7.779 -2.298,11.064 -0.392,-4.178 -4.263,-14.571 -33.062,-14.571 -36.044,0 -49.99,2.713 -51.92,23.607 -1.932,20.893 -15.232,103.463 12.766,133.948 24.864,27.073 41.627,4.639 45.069,-0.723 -0.29,8.266 -0.656,16.055 -1.061,23.248 -1.021,14.422 -2.154,30.331 -2.345,32.658 -0.129,1.465 -0.256,2.871 -0.377,4.174 0,0 7.524,19.032 10.604,27.721"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572.0439,276.084)",
    id: "g870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path872",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -1.762,-2.501 -3.74,-4.862 -5.853,-7.122 -2.148,-2.224 -4.464,-4.31 -6.932,-6.216 -4.942,-3.818 -10.531,-6.748 -16.195,-9.081 -5.7,-2.336 -11.593,-4.155 -17.577,-5.522 -2.99,-0.702 -6.016,-1.228 -9.057,-1.677 -1.522,-0.224 -3.051,-0.408 -4.587,-0.572 -1.562,-0.152 -3.036,-0.286 -4.733,-0.352 l 3.646,4.578 c 3.105,-14.36 5.469,-28.859 7.308,-43.41 1.776,-14.561 2.986,-29.178 3.715,-43.811 0.724,-14.631 0.987,-29.285 0.836,-43.917 l -0.159,-10.951 -0.074,-5.395 c -0.012,-1.574 0.144,-3.077 0.447,-4.669 1.248,-6.304 4.352,-12.625 8.57,-17.482 2.122,-2.406 4.585,-4.426 7.185,-5.576 1.295,-0.58 2.612,-0.917 3.909,-1.002 l 0.487,-0.021 0.253,-0.013 h 0.341 l 1.366,0.001 2.731,0.001 21.846,0.009 43.692,0.018 5.461,0.002 h 1.365 l 0.672,0.002 0.438,0.016 c 0.581,0.04 1.156,0.147 1.722,0.323 2.269,0.684 4.394,2.577 5.784,5.038 1.411,2.46 2.127,5.423 2.087,8.38 0.005,0.733 -0.072,1.466 -0.176,2.331 -0.1,0.83 -0.167,1.666 -0.333,2.48 -0.265,1.641 -0.624,3.258 -1.093,4.833 -0.923,3.156 -2.252,6.157 -3.965,8.918 -1.739,2.743 -3.852,5.252 -6.293,7.436 -2.439,2.185 -5.182,4.071 -8.127,5.609 -1.469,0.772 -2.988,1.461 -4.534,2.056 -0.773,0.304 -1.555,0.569 -2.333,0.819 -0.39,0.122 -0.778,0.237 -1.162,0.342 -0.354,0.096 -0.823,0.216 -1.036,0.259 l -0.008,0.002 c -2.086,0.421 -3.484,2.363 -3.299,4.435 1.67,17.994 2.66,36.063 3.134,54.152 0.126,4.521 0.177,9.047 0.252,13.571 0.012,4.526 0.085,9.05 0.044,13.576 0.015,9.052 -0.169,18.106 -0.389,27.158 -0.255,9.05 -0.62,18.099 -1.087,27.143 -0.239,4.522 -0.503,9.041 -0.795,13.56 l -0.463,6.775 c -0.164,2.269 -0.301,4.714 -0.315,7.066 -0.045,4.748 0.278,9.492 0.926,14.183 0.324,2.347 0.73,4.68 1.216,6.995 0.245,1.158 0.511,2.31 0.789,3.458 0.249,1.077 0.52,2.138 0.749,3.223 1.886,8.632 3.178,17.607 4.092,26.438 l 0.009,0.082 c 0.228,2.197 2.193,3.793 4.391,3.566 2.197,-0.228 3.795,-2.183 3.567,-4.38 C 41.521,58.415 40.248,49.362 38.287,40.224 38.049,39.085 37.762,37.942 37.502,36.805 37.248,35.744 37.003,34.683 36.78,33.616 36.336,31.482 35.965,29.336 35.671,27.18 35.083,22.867 34.793,18.518 34.842,14.176 34.861,11.982 34.979,9.888 35.146,7.624 L 35.63,0.798 c 0.306,-4.552 0.582,-9.106 0.834,-13.66 0.491,-9.111 0.881,-18.226 1.16,-27.346 0.526,-18.24 0.644,-36.499 0.139,-54.755 -0.493,-18.255 -1.507,-36.508 -3.212,-54.716 l -3.307,4.436 c 0.678,-0.142 1.089,-0.257 1.614,-0.396 0.494,-0.136 0.978,-0.281 1.456,-0.43 0.956,-0.307 1.898,-0.629 2.821,-0.992 1.85,-0.713 3.652,-1.533 5.405,-2.456 3.507,-1.836 6.813,-4.103 9.796,-6.779 2.982,-2.674 5.608,-5.786 7.761,-9.195 2.128,-3.427 3.764,-7.147 4.88,-10.98 0.567,-1.914 0.997,-3.859 1.31,-5.811 0.192,-0.975 0.277,-1.954 0.393,-2.932 0.05,-0.502 0.121,-0.952 0.153,-1.495 0.04,-0.538 0.065,-1.076 0.068,-1.616 0.047,-4.317 -0.97,-8.688 -3.183,-12.557 -1.109,-1.93 -2.521,-3.734 -4.275,-5.266 -1.739,-1.536 -3.847,-2.79 -6.198,-3.513 -1.171,-0.363 -2.397,-0.592 -3.632,-0.672 l -0.927,-0.031 -0.695,-0.001 -1.365,0.001 -5.461,0.002 -43.692,0.018 -21.846,0.009 -2.731,0.001 -1.366,0.001 h -0.341 l -0.428,0.015 -0.878,0.039 c -2.337,0.158 -4.594,0.771 -6.62,1.677 -4.075,1.827 -7.307,4.615 -9.994,7.647 -2.682,3.058 -4.832,6.434 -6.582,9.995 -1.738,3.567 -3.084,7.328 -3.851,11.335 -0.381,1.983 -0.602,4.12 -0.584,6.188 l 0.08,5.526 0.168,10.892 c 0.161,14.495 -0.088,28.977 -0.791,43.438 -0.709,14.459 -1.893,28.89 -3.632,43.244 -1.677,14.361 -3.943,28.644 -6.786,42.801 l -0.009,0.045 c -0.412,2.052 0.917,4.048 2.968,4.459 0.224,0.045 0.468,0.069 0.687,0.074 1.282,0.02 2.78,0.11 4.186,0.216 1.43,0.118 2.862,0.256 4.293,0.431 2.863,0.345 5.72,0.799 8.555,1.352 5.672,1.099 11.258,2.622 16.658,4.626 5.426,2.004 10.586,4.427 15.348,7.546 2.387,1.548 4.665,3.279 6.823,5.172 2.196,1.855 4.241,3.902 6.256,6.01 l 0.015,0.015 c 0.726,0.759 1.93,0.785 2.689,0.06 C 0.449,1.811 0.534,0.757 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(601.8457,122.8457)",
    id: "g874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path876",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -0.306,0.031 -0.862,0.085 -1.322,0.107 l -1.47,0.068 c -0.989,0.039 -1.989,0.035 -2.99,0.016 -2.004,-0.033 -4.013,-0.188 -6.008,-0.433 -1.993,-0.264 -3.974,-0.624 -5.925,-1.103 -1.947,-0.492 -3.865,-1.096 -5.753,-1.797 -3.748,-1.461 -7.336,-3.391 -10.626,-5.835 -3.256,-2.5 -6.349,-5.199 -10.117,-7.881 -0.158,-0.116 -0.381,-0.08 -0.496,0.078 -0.063,0.085 -0.08,0.194 -0.06,0.29 1.071,4.562 3.732,8.499 7.045,11.725 1.683,1.59 3.452,3.115 5.359,4.472 1.903,1.359 3.93,2.552 6.029,3.606 2.101,1.05 4.285,1.934 6.522,2.65 2.234,0.731 4.52,1.296 6.835,1.677 2.312,0.408 4.653,0.622 7.003,0.69 1.175,0.044 2.355,0.01 3.541,-0.043 0.594,-0.024 1.188,-0.075 1.79,-0.138 C -0.017,8.085 0.51,8.021 1.282,7.896 3.461,7.542 4.94,5.488 4.586,3.31 4.244,1.21 2.325,-0.239 0.236,-0.025 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(544.6514,257.0146)",
    id: "g878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path880",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 -0.597,-26.686 2.837,-56.882 l -31.799,-17.69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(517.7666,156.2979)",
    id: "g882"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path884",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 50.089,20.573 87.105,3.811"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g886"
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "g888"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g900"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    },
    id: "g898",
    clipPath: "url(#clipPath892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g896",
    transform: "translate(619.6523,105.6289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path894",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 -6.598,10.438 -22.528,11.63 -38.458,12.821 -24.78,1.832 -11.264,-1.425 2.252,-4.681 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.5825,160.1084)",
    id: "g902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path904",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.078,61.395 0.98,117.387 3.332,142.625 0.881,9.457 -7.525,19.031 -10.604,27.721 L 37.056,115.041 C 60.207,89.776 97.826,77.536 97.826,77.536 91.292,46.689 88.358,18.751 87.104,-3.811 87.104,-3.811 37.017,16.763 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(358.686,89.3281)",
    id: "g906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path908",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 2.682,31.605 32.282,37.466 32.282,37.466 -1.058,11.18 -1.835,22.334 -2.386,33.314 37.017,16.763 87.105,-3.81 87.105,-3.81 -1.519,-27.345 -0.569,-46.788 -0.569,-53.925 0,-13.024 -11.344,-32.562 -24.861,-32.562 H 14.082 C 5.764,-19.517 -0.888,-10.461 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g910"
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "g912"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g924"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    },
    id: "g922",
    clipPath: "url(#clipPath916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g920",
    transform: "translate(441.3535,163.4248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path918",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -35.293,-4.07 -40.228,-6.105 -4.934,-2.036 -2.467,-29.441 -2.467,-29.441 0,0 -3.755,-0.407 -4.613,0 -0.858,0.407 -3.432,2.307 -3.432,2.307 0,0 -2.239,26.862 -2.031,27.134 0.207,0.271 2.385,3.813 2.385,3.813 0,0 2.006,5.284 24.426,5.552 C -3.54,3.527 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448.8027,257.0146)",
    id: "g926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path928",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 0.597,-26.686 -2.836,-56.882 l 31.798,-17.69 c 0,0 2.104,18.818 4.073,30.731 1.969,11.913 4.571,36.16 4.571,36.16 L 8.578,-3.4 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g930"
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "g932"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g944"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g942",
    clipPath: "url(#clipPath936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g940",
    transform: "translate(387.4731,241.5713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path938",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 0.816,11.583 1.719,24.33 1.313,17.137 0.948,9.348 0.658,1.082 0.224,0.406 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g946"
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "g948"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g960"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g958",
    clipPath: "url(#clipPath952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g956",
    transform: "translate(381.3101,330.4541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path954",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 44.328,-55.305 c 23.151,-25.264 60.771,-25.815 60.771,-25.815 -6.535,-30.847 -9.469,-70.475 -10.722,-93.036 -1.519,-27.345 -0.569,-46.788 -0.569,-53.925 0,-13.024 -11.344,-32.562 -24.861,-32.562 H -8.542 c -8.318,0 -14.97,9.056 -14.082,19.517 0.349,4.112 1.161,7.779 2.297,11.064 0.393,-4.178 4.263,-14.571 33.063,-14.571 36.044,0 49.99,2.713 51.92,23.607 1.931,20.893 15.231,103.463 -12.766,133.948 -24.864,27.073 -41.628,4.639 -45.069,-0.723 0.29,8.266 0.656,16.055 1.061,23.248 1.021,14.422 2.154,30.331 2.345,32.658 0.129,1.465 0.256,2.871 0.377,4.174 0,0 -7.524,19.032 -10.604,27.721"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(424.3545,278.4785)",
    id: "g962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path964",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 2.015,-2.107 4.06,-4.154 6.256,-6.01 2.158,-1.892 4.436,-3.624 6.824,-5.172 4.761,-3.119 9.921,-5.542 15.347,-7.546 5.399,-2.003 10.987,-3.527 16.658,-4.626 2.835,-0.552 5.691,-1.006 8.554,-1.351 1.431,-0.176 2.864,-0.314 4.294,-0.432 1.406,-0.105 2.904,-0.196 4.185,-0.216 2.092,-0.032 3.761,-1.753 3.729,-3.845 -0.003,-0.228 -0.027,-0.45 -0.069,-0.667 l -0.014,-0.066 c -2.842,-14.157 -5.108,-28.439 -6.785,-42.8 -1.739,-14.355 -2.923,-28.786 -3.632,-43.245 -0.703,-14.461 -0.952,-28.943 -0.791,-43.437 l 0.167,-10.893 0.081,-5.526 c 0.018,-2.067 -0.203,-4.204 -0.585,-6.188 -0.766,-4.006 -2.113,-7.767 -3.849,-11.334 -1.751,-3.561 -3.901,-6.938 -6.582,-9.996 -2.688,-3.032 -5.921,-5.82 -9.995,-7.646 -2.026,-0.906 -4.283,-1.52 -6.62,-1.678 l -0.878,-0.039 -0.428,-0.015 h -0.342 l -1.365,-0.001 h -2.731 l -21.846,-0.009 -43.692,-0.019 -5.461,-0.002 -1.366,-0.001 -0.694,0.001 -0.927,0.031 c -1.235,0.081 -2.461,0.309 -3.632,0.672 -2.351,0.723 -4.459,1.978 -6.198,3.513 -1.755,1.532 -3.167,3.337 -4.275,5.267 -2.213,3.869 -3.231,8.24 -3.183,12.556 0.002,0.54 0.028,1.078 0.068,1.616 0.032,0.543 0.102,0.994 0.153,1.496 0.115,0.977 0.201,1.957 0.393,2.931 0.313,1.952 0.743,3.898 1.31,5.812 1.116,3.833 2.753,7.553 4.88,10.979 2.152,3.409 4.779,6.522 7.761,9.196 2.983,2.675 6.289,4.943 9.796,6.779 1.753,0.923 3.555,1.742 5.405,2.456 0.923,0.362 1.866,0.684 2.82,0.991 0.479,0.15 0.963,0.294 1.456,0.431 0.526,0.138 0.937,0.254 1.615,0.395 l -3.307,-4.435 c -1.705,18.208 -2.718,36.461 -3.212,54.716 -0.505,18.255 -0.388,36.514 0.139,54.754 0.279,9.121 0.669,18.236 1.16,27.346 0.252,4.555 0.529,9.109 0.834,13.66 l 0.483,6.826 c 0.167,2.264 0.286,4.359 0.305,6.552 0.049,4.342 -0.241,8.692 -0.829,13.004 -0.294,2.156 -0.665,4.303 -1.11,6.437 -0.222,1.066 -0.467,2.128 -0.721,3.188 -0.26,1.138 -0.547,2.28 -0.785,3.419 -1.962,9.139 -3.235,18.192 -4.168,27.442 -0.222,2.197 1.38,4.159 3.578,4.38 2.198,0.222 4.159,-1.38 4.381,-3.578 l 0.007,-0.07 c 0.915,-8.831 2.207,-17.807 4.092,-26.439 0.23,-1.085 0.501,-2.145 0.75,-3.222 0.278,-1.149 0.545,-2.301 0.788,-3.458 0.487,-2.316 0.893,-4.649 1.218,-6.995 0.646,-4.692 0.97,-9.436 0.924,-14.184 -0.013,-2.351 -0.151,-4.797 -0.314,-7.065 l -0.463,-6.776 c -0.292,-4.518 -0.556,-9.038 -0.795,-13.559 -0.467,-9.044 -0.832,-18.093 -1.087,-27.144 -0.22,-9.052 -0.405,-18.105 -0.388,-27.157 -0.042,-4.526 0.03,-9.051 0.043,-13.576 0.076,-4.525 0.126,-9.05 0.252,-13.572 0.474,-18.088 1.464,-36.158 3.134,-54.152 0.196,-2.119 -1.242,-4.012 -3.279,-4.431 l -0.027,-0.005 c -0.215,-0.043 -0.684,-0.164 -1.037,-0.259 -0.385,-0.106 -0.773,-0.221 -1.162,-0.343 -0.779,-0.25 -1.561,-0.515 -2.333,-0.818 -1.547,-0.595 -3.065,-1.285 -4.534,-2.057 -2.945,-1.537 -5.687,-3.424 -8.128,-5.608 -2.44,-2.185 -4.553,-4.694 -6.292,-7.437 -1.713,-2.761 -3.042,-5.762 -3.965,-8.918 -0.469,-1.574 -0.828,-3.191 -1.092,-4.833 -0.166,-0.813 -0.234,-1.649 -0.334,-2.479 -0.104,-0.866 -0.181,-1.599 -0.177,-2.331 -0.04,-2.957 0.678,-5.92 2.087,-8.38 1.391,-2.461 3.516,-4.355 5.784,-5.038 0.567,-0.176 1.142,-0.284 1.724,-0.324 l 0.437,-0.015 0.671,-0.002 h 1.366 l 5.461,-0.002 43.692,-0.019 21.846,-0.009 h 2.731 l 1.365,-10e-4 h 0.342 l 0.253,0.012 0.486,0.022 c 1.297,0.085 2.614,0.422 3.91,1.002 2.599,1.149 5.063,3.17 7.185,5.576 4.218,4.856 7.322,11.178 8.57,17.481 0.303,1.592 0.458,3.095 0.447,4.669 l -0.074,5.396 -0.16,10.951 c -0.15,14.632 0.113,29.285 0.837,43.917 0.729,14.633 1.939,29.25 3.715,43.81 1.839,14.551 4.202,29.05 7.308,43.411 l 3.646,-4.579 c -1.697,0.067 -3.171,0.201 -4.733,0.352 -1.536,0.164 -3.066,0.349 -4.587,0.572 -3.041,0.45 -6.067,0.976 -9.057,1.677 -5.984,1.367 -11.878,3.187 -17.577,5.523 -5.664,2.333 -11.254,5.262 -16.195,9.081 -2.468,1.906 -4.784,3.992 -6.932,6.215 -2.113,2.26 -4.092,4.621 -5.853,7.122 -0.605,0.86 -0.399,2.045 0.46,2.651 0.779,0.549 1.83,0.43 2.469,-0.24 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.3262,130.7422)",
    id: "g966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path968",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0.772,0.125 1.299,0.188 1.925,0.253 0.602,0.062 1.197,0.113 1.79,0.138 1.186,0.052 2.366,0.087 3.541,0.043 2.351,-0.069 4.691,-0.283 7.003,-0.691 2.315,-0.381 4.601,-0.945 6.834,-1.677 2.238,-0.715 4.423,-1.599 6.523,-2.649 2.099,-1.055 4.126,-2.247 6.03,-3.606 1.906,-1.358 3.675,-2.882 5.358,-4.472 3.313,-3.227 5.975,-7.163 7.044,-11.726 0.045,-0.19 -0.073,-0.382 -0.264,-0.426 -0.103,-0.025 -0.21,0.002 -0.29,0.058 -3.768,2.683 -6.862,5.382 -10.118,7.882 -3.29,2.443 -6.878,4.374 -10.626,5.835 -1.888,0.7 -3.805,1.305 -5.753,1.797 -1.951,0.478 -3.932,0.839 -5.924,1.102 -1.995,0.245 -4.004,0.401 -6.008,0.434 -1.002,0.018 -2.002,0.022 -2.991,-0.017 L 2.604,-7.789 C 2.145,-7.812 1.588,-7.865 1.283,-7.896 L 1.058,-7.92 C -1.138,-8.15 -3.104,-6.557 -3.333,-4.361 -3.555,-2.246 -2.072,-0.342 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(448.8027,257.0146)",
    id: "g970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path972",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 0.597,-26.686 -2.836,-56.882 l 31.798,-17.69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(475.687,156.2979)",
    id: "g974"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path976",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -50.088,20.573 -87.105,3.811"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g978"
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "g980"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g992"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    },
    id: "g990",
    clipPath: "url(#clipPath984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g988",
    transform: "translate(373.8022,105.6289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path986",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 6.597,10.438 22.527,11.63 38.458,12.821 24.78,1.832 11.264,-1.425 -2.253,-4.681 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.5986,313.8369)",
    id: "g994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path996",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -101.568 c -14.694,0 -26.606,11.912 -26.606,26.606 v 35.183 c 0,14.694 11.912,26.606 26.606,26.606 L 0,88.395 c 14.693,0 26.605,-11.912 26.605,-26.606 V 26.606 C 26.605,11.912 14.693,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g998"
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "g1000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1012"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g1010",
    clipPath: "url(#clipPath1004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1008",
    transform: "translate(550.749,332.4932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1006",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -107.87 c -12.953,0 -23.455,13.512 -23.455,30.18 V 11.524 c 0,-16.668 10.502,-30.18 23.455,-30.18 H 0 c 12.954,0 23.455,13.512 23.455,30.18 V 30.18 C 23.455,13.512 12.954,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.5986,313.8369)",
    id: "g1014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1016",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -101.568 c -14.694,0 -26.606,11.912 -26.606,26.606 v 35.183 c 0,14.694 11.912,26.606 26.606,26.606 L 0,88.395 c 14.693,0 26.605,-11.912 26.605,-26.606 V 26.606 C 26.605,11.912 14.693,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(555.6943,415.7402)",
    id: "g1018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1020",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 30.297,54.242 74.142,94.465 1.587,1.455 -12.344,6.077 -29.143,3.251 0,0 -47.246,-40.076 -69.895,-97.716"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(555.6943,415.7402)",
    id: "g1022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1024",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -24.896 l -5.933,-13.509 h 24.895 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1026"
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "g1028"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1040"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g1038",
    clipPath: "url(#clipPath1032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1036",
    transform: "translate(540.2803,403.4873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1034",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 13.876,31.038 36.747,62.489 h 11.887 c 0,0 1.497,1.708 2.003,2.267 0.506,0.557 1.403,2.996 1.403,2.996 0,0 -2.507,1.401 -3.687,1.477 -1.181,0.077 -7.694,0.58 -7.694,0.58 0,0 26.808,32.424 31.549,33.859 4.742,1.435 13.382,-0.662 13.382,-0.662 l 3.966,3.712 c 0,0 -34.236,-35.437 -53.441,-62.213 C 16.91,17.729 9.068,-0.418 9.068,-0.418 c 0,0 -2.551,-0.838 -3.144,-0.838 C 5.331,-1.256 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(555.6943,415.7402)",
    id: "g1042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1044",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -24.896 l -5.933,-13.509 h 24.895 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(555.6943,415.7402)",
    id: "g1046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1048",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 0,0 30.297,54.242 74.142,94.465 1.587,1.455 -12.344,6.077 -29.143,3.251 0,0 -47.246,-40.076 -69.895,-97.716"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(549.3486,452.2734)",
    id: "g1050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1052",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 H 28.63"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(564.5957,474.2666)",
    id: "g1054"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1056",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 30.139,-1.942"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.9053,415.7402)",
    id: "g1058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1060",
    style: {
      fill: "#777777",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 C 0,0 -30.297,54.242 -74.142,94.465 -75.728,95.92 -61.798,100.542 -45,97.716 -45,97.716 2.247,57.64 24.896,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.9053,415.7402)",
    id: "g1062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1064",
    style: {
      fill: "#00c7be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 24.896 l 5.933,-13.509 H 5.933 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1066"
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "g1068"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1080"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g1078",
    clipPath: "url(#clipPath1072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1076",
    transform: "translate(453.3193,403.4873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1074",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 -13.876,31.038 -36.748,62.489 h -11.886 c 0,0 -1.497,1.708 -2.003,2.267 -0.506,0.557 -1.404,2.996 -1.404,2.996 0,0 2.507,1.401 3.688,1.477 1.181,0.077 7.693,0.58 7.693,0.58 0,0 -26.807,32.424 -31.548,33.859 -4.743,1.435 -13.382,-0.662 -13.382,-0.662 l -3.966,3.712 c 0,0 34.235,-35.437 53.44,-62.213 19.206,-26.776 27.047,-44.923 27.047,-44.923 0,0 2.552,-0.838 3.145,-0.838 C -5.332,-1.256 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.9053,415.7402)",
    id: "g1082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1084",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h 24.896 l 5.933,-13.509 H 5.933 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(437.9053,415.7402)",
    id: "g1086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1088",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -30.297,54.242 -74.142,94.465 -75.728,95.92 -61.798,100.542 -45,97.716 -45,97.716 2.247,57.64 24.896,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(444.2505,452.2734)",
    id: "g1090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1092",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 H -28.63"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(429.0039,474.2666)",
    id: "g1094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1096",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 -30.139,-1.942"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(542.376,351.7607)",
    id: "g1098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1100",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h -18.329 c -4.924,0 -8.915,3.992 -8.915,8.915 v 13.824 c 0,4.924 3.991,8.915 8.915,8.915 H 0 c 4.923,0 8.915,-3.991 8.915,-8.915 V 8.915 C 8.915,3.992 4.923,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(542.376,351.7607)",
    id: "g1102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1104",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -18.329 c -4.924,0 -8.915,3.992 -8.915,8.915 v 13.824 c 0,4.924 3.991,8.915 8.915,8.915 H 0 c 4.923,0 8.915,-3.991 8.915,-8.915 V 8.915 C 8.915,3.992 4.923,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(540.3662,374.7402)",
    id: "g1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1108",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -4.687,3.959 -7.155,-2.565 -7.155,-2.565 0,0 -2.467,6.524 -7.155,2.565 -4.351,-3.674 0.652,-8.835 3.468,-10.849 1.224,-0.875 3.687,-4.567 3.687,-4.567 0,0 2.464,3.692 3.687,4.567 C -0.651,-8.835 4.352,-3.674 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(467.7729,379.6543)",
    id: "g1110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1112",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 0 c 0,-3.433 2.163,-6.217 4.832,-6.217 h 15.262 c 2.668,0 4.832,2.784 4.832,6.217 0,3.434 -2.164,6.217 -4.832,6.217 H 4.832 C 2.163,6.217 0,3.434 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(469.1567,351.8174)",
    id: "g1114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1116",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 18.71 c 2.668,0 4.832,2.784 4.832,6.217 0,3.433 -2.164,6.217 -4.832,6.217 H 0 C -2.668,12.434 -4.832,9.65 -4.832,6.217 -4.832,2.784 -2.668,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.6309,330.1973)",
    id: "g1118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1120",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 h 33.236 c 2.668,0 4.832,2.784 4.832,6.217 0,3.433 -2.164,6.217 -4.832,6.217 H 0 C -2.668,12.434 -4.832,9.65 -4.832,6.217 -4.832,2.784 -2.668,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.9517,379.832)",
    id: "g1122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1124",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -0.355 c 0,-2.541 1.601,-4.601 3.576,-4.601 h 37.726 c 1.975,0 3.575,2.06 3.575,4.601 V 0 c 0,2.541 -1.6,4.601 -3.575,4.601 H 3.576 C 1.601,4.601 0,2.541 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.9517,358.0723)",
    id: "g1126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1128",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v -0.075 c 0,-2.541 1.601,-4.601 3.576,-4.601 h 43.83 c 1.975,0 3.576,2.06 3.576,4.601 V 0 c 0,2.541 -1.601,4.601 -3.576,4.601 H 3.576 C 1.601,4.601 0,2.541 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(435.9517,336.4141)",
    id: "g1130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1132",
    style: {
      fill: "#ff546a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 0 c 0,-2.54 1.601,-4.601 3.576,-4.601 h 24.67 c 1.974,0 3.575,2.061 3.575,4.601 0,2.541 -1.601,4.601 -3.575,4.601 H 3.576 C 1.601,4.601 0,2.541 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(487.2183,373.4375)",
    id: "g1134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1136",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -45.786 c -3.027,0 -5.481,2.454 -5.481,5.48 v 1.473 c 0,3.027 2.454,5.481 5.481,5.481 H 0 c 3.026,0 5.48,-2.454 5.48,-5.481 V 5.48 C 5.48,2.454 3.026,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(487.2183,351.8174)",
    id: "g1138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1140",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -45.786 c -3.027,0 -5.481,2.454 -5.481,5.48 v 1.473 c 0,3.027 2.454,5.481 5.481,5.481 H 0 c 3.026,0 5.48,-2.454 5.48,-5.481 V 5.48 C 5.48,2.454 3.026,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(487.2183,330.1973)",
    id: "g1142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1144",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 h -45.786 c -3.027,0 -5.481,2.454 -5.481,5.48 v 1.473 c 0,3.027 2.454,5.481 5.481,5.481 H 0 c 3.026,0 5.48,-2.454 5.48,-5.481 V 5.48 C 5.48,2.454 3.026,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.2109,383.415)",
    id: "g1146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1148",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V 18.909"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(533.2109,351.7607)",
    id: "g1150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1152",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 V -37.924"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1154"
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "g1156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1168"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g1166",
    clipPath: "url(#clipPath1160)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1164",
    transform: "translate(498.4302,514.2886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1162",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 0,0 98.797,28.424 120.826,0 0,0 -25.065,-30.669 -67.885,-43.989 C 37.492,-48.795 19.73,-48.786 0,-48.786 c -20.763,0 -39.346,0.342 -55.349,5.564 C -96.7,-29.729 -120.826,0 -120.826,0 -98.797,28.424 0,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.855,573.3931)",
    id: "g1170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1172",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 0 c 12.435,0 22.516,10.081 22.516,22.516 v 57.71 c 0,12.435 -10.081,22.515 -22.516,22.515 -12.435,0 -22.516,-10.08 -22.516,-22.515 V 22.516 C -22.516,10.081 -12.435,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1174"
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "g1176"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1188"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g1186",
    clipPath: "url(#clipPath1180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1184",
    transform: "translate(329.855,606.7427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1182",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 0 C 12.435,0 22.516,10.63 22.516,23.743 V -9.607 C 22.516,-22.72 12.435,-33.35 0,-33.35 c -12.435,0 -22.516,10.63 -22.516,23.743 v 33.35 C -22.516,10.63 -12.435,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(329.855,573.3931)",
    id: "g1190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1192",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 v 0 c 12.435,0 22.516,10.081 22.516,22.516 v 57.71 c 0,12.435 -10.081,22.515 -22.516,22.515 -12.435,0 -22.516,-10.08 -22.516,-22.515 V 22.516 C -22.516,10.081 -12.435,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(663.5996,573.3931)",
    id: "g1194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1196",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 v 0 c 12.435,0 22.516,10.081 22.516,22.516 v 57.71 c 0,12.435 -10.081,22.515 -22.516,22.515 -12.436,0 -22.516,-10.08 -22.516,-22.515 V 22.516 C -22.516,10.081 -12.436,0 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1198"
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "g1200"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1212"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g1210",
    clipPath: "url(#clipPath1204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1208",
    transform: "translate(663.5996,606.7427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1206",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 0,0 V 0 C 12.435,0 22.516,10.63 22.516,23.743 V -9.607 C 22.516,-22.72 12.435,-33.35 0,-33.35 c -12.436,0 -22.516,10.63 -22.516,23.743 v 33.35 C -22.516,10.63 -12.436,0 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(663.5996,573.3931)",
    id: "g1214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1216",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 v 0 c 12.435,0 22.516,10.081 22.516,22.516 v 57.71 c 0,12.435 -10.081,22.515 -22.516,22.515 -12.436,0 -22.516,-10.08 -22.516,-22.515 V 22.516 C -22.516,10.081 -12.436,0 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441.5063,800.1499)",
    id: "g1218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1220",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 35.647,10.06 73.611,10.06 109.258,0 113.544,-32.041 132.037,-151.77 106.102,-230.764 -29.642,-90.278 -160.731,-80.241 -160.731,-80.241 0,0 -131.089,-10.037 -160.731,80.241 C -132.038,-151.77 -113.544,-32.041 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(444.1055,725.1289)",
    id: "g1222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1224",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 -3.106,45.036 -39.626,59.819"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(548.1738,725.1289)",
    id: "g1226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1228",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 0,0 3.106,45.036 39.626,59.819"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1230"
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "g1232"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1244"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000299
    },
    id: "g1242",
    clipPath: "url(#clipPath1236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1240",
    transform: "translate(344.894,725.9473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1238",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -15.841,-42.298 -14.271,-75.618 -1.675,-115.944 28.2,-90.279 152.917,-83.743 152.917,-83.743 0,0 124.716,-6.536 152.916,83.743 12.596,40.326 14.167,73.646 -1.675,115.944 24.625,-45.726 24.512,-111.753 9.489,-157.508 -29.641,-90.279 -160.73,-79.295 -160.73,-79.295 0,0 -131.09,-10.984 -160.731,79.295 C -24.512,-111.753 -24.625,-45.726 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441.5063,800.1499)",
    id: "g1246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1248",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0,0 C 18.491,5.218 37.604,7.729 56.695,7.534 74.408,7.353 92.101,4.842 109.258,0 c 70.586,-19.918 104.439,-70.432 113.719,-124.782 5.648,-33.077 2.195,-77.042 -7.617,-106.928 -29.642,-90.28 -160.731,-82.104 -160.731,-82.104 0,0 -131.089,-8.176 -160.731,82.104 -10.229,31.155 -13.547,76.788 -6.848,111.132 C -102.665,-67.843 -68.762,-19.404 0,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.5127,683.5425)",
    id: "g1250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1252",
    style: {
      fill: "#2d2d2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 17.385,26.077 68.119,45.506 138.623,45.506 70.503,0 121.238,-19.429 138.623,-45.506 17.384,-26.077 26.076,-100.217 -2.557,-128.851 -28.633,-28.633 -136.066,-27.61 -136.066,-27.61 0,0 -107.433,-1.023 -136.066,27.61 C -26.077,-100.217 -17.385,-26.077 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1254"
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "g1256"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1268"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g1266",
    clipPath: "url(#clipPath1260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1264",
    transform: "translate(394.5859,669.9102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1262",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 17.599,24.479 120.474,46.947 113.646,46.947 -72.405,0 -124.507,-18.503 -142.361,-43.336 -10.593,-14.735 -18.044,-45.584 -16.209,-73.932 0.219,-3.384 2.487,-6.292 5.687,-7.416 v 0 c 10.211,-3.59 21.047,3.65 21.547,14.463 1.175,25.415 8.291,50.2 17.69,63.274"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g1270"
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "g1272"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1284"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g1282",
    clipPath: "url(#clipPath1276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1280",
    transform: "translate(642.3281,621.5186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1278",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -2.338,-10.809 -11.339,-18.035 -20.104,-16.139 -8.766,1.896 -13.977,12.195 -11.639,23.005 2.338,10.809 11.339,18.035 20.104,16.139 C -2.873,21.109 2.338,10.81 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g1286"
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "g1288"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1300"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39999402
    },
    id: "g1298",
    clipPath: "url(#clipPath1292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1296",
    transform: "translate(613.1777,581.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1294",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c -3.338,-4.614 -9.784,-5.647 -14.398,-2.309 -4.614,3.338 -5.648,9.785 -2.309,14.398 3.339,4.614 9.785,5.648 14.398,2.309 C 2.305,11.06 3.339,4.613 0,0"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360.0693,583.5977)",
    id: "g1302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1304",
    style: {
      fill: "#161616",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 c 28.633,-28.633 136.066,-27.61 136.066,-27.61 0,0 107.433,-1.023 136.067,27.61 10.698,10.699 16.184,27.752 17.955,46.276 2.477,-28.34 -1.788,-59.015 -17.955,-75.182 -28.634,-28.634 -136.067,-27.611 -136.067,-27.611 0,0 -107.433,-1.023 -136.066,27.611 -16.167,16.167 -20.433,46.843 -17.955,75.182 C -16.185,27.752 -10.699,10.699 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.5127,683.5425)",
    id: "g1306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1308",
    style: {
      fill: "none",
      stroke: "#2d2d2d",
      strokeWidth: 8,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 0,0 c 17.385,26.077 68.119,45.506 138.623,45.506 70.503,0 121.238,-19.429 138.623,-45.506 17.384,-26.077 26.076,-100.217 -2.557,-128.851 -28.633,-28.633 -136.066,-27.61 -136.066,-27.61 0,0 -107.433,-1.023 -136.066,27.61 C -26.077,-100.217 -17.385,-26.077 0,0 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstronoutStandingCongratulate);
export default __webpack_public_path__ + "static/media/astronout-standing-congratulate.e63008d6d0c06078d18abd76ca0743c3.svg";
export { ForwardRef as ReactComponent };